import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
};

export enum Aggr_Search_Sort_Types {
  Conversion = 'CONVERSION',
  RanCount = 'RAN_COUNT',
  SaleAmtAvg = 'SALE_AMT_AVG',
  SaleAmtSum = 'SALE_AMT_SUM',
  SoldCount = 'SOLD_COUNT'
}

export type AmsUpdateResponseMessages = {
  __typename?: 'AMSUpdateResponseMessages';
  error?: Maybe<Array<Maybe<Scalars['String']>>>;
  statusCode?: Maybe<Scalars['Int']>;
  statusText?: Maybe<Scalars['String']>;
  success?: Maybe<Array<Maybe<Scalars['String']>>>;
  warning?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum AccessoryDrawerDisplay {
  WidgetConfig = 'WIDGET_CONFIG'
}

export type Account = {
  __typename?: 'Account';
  accountId: Scalars['Int'];
  accountKey: Scalars['String'];
  accountNotes?: Maybe<Array<Maybe<AccountNote>>>;
  accountOrgDisplayName?: Maybe<Scalars['String']>;
  accountOrgId: Scalars['Int'];
  accountSalesRep?: Maybe<Scalars['String']>;
  accountTypeCode?: Maybe<Scalars['String']>;
  agents?: Maybe<Agents>;
  auctionAccessNumber?: Maybe<Scalars['Int']>;
  canBuy?: Maybe<Scalars['Boolean']>;
  canSell?: Maybe<Scalars['Boolean']>;
  dbaName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  establishedAt?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  lastAttended?: Maybe<Scalars['String']>;
  lastPurchaseActivity?: Maybe<Scalars['String']>;
  lastSoldActivity?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  orgCode?: Maybe<Scalars['String']>;
  phoneMain?: Maybe<Scalars['String']>;
  phoneMobile?: Maybe<Scalars['String']>;
  phoneSecondary?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type AccountGroupAccounts = {
  __typename?: 'AccountGroupAccounts';
  accountGroupId?: Maybe<Scalars['Int']>;
  accountId?: Maybe<Scalars['Int']>;
};

export type AccountGroupUsers = {
  __typename?: 'AccountGroupUsers';
  accountGroupId?: Maybe<Scalars['Int']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type AccountGroups = {
  __typename?: 'AccountGroups';
  accounts?: Maybe<Array<Maybe<AccountGroupAccounts>>>;
  description?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isShared?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  orgId?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<AccountGroupUsers>>>;
};

export type AccountGroupsFilter = {
  accountGroupId?: InputMaybe<Scalars['Int']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type AccountNote = {
  __typename?: 'AccountNote';
  position?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type AccountSortBy = {
  ascending: Scalars['Boolean'];
  key: AccountSortingKey;
};

export enum AccountSortingKey {
  AccountNumber = 'AccountNumber',
  EstablishedAt = 'EstablishedAt',
  LegalName = 'LegalName',
  MailingLocationCity = 'MailingLocationCity',
  PrimaryLocationCity = 'PrimaryLocationCity'
}

export type Accounts = {
  __typename?: 'Accounts';
  byId?: Maybe<Account>;
  count?: Maybe<Scalars['Int']>;
  docsByDocTypeShortCode?: Maybe<Array<Maybe<Document>>>;
  list?: Maybe<Array<Maybe<Account>>>;
};


export type AccountsDocsByDocTypeShortCodeArgs = {
  docTypeShortCode?: InputMaybe<Scalars['String']>;
};


export type AccountsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  sortBy?: InputMaybe<AccountSortBy>;
};

export type AccountsFilter = {
  auctionAccessNumber?: InputMaybe<Scalars['Int']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  establishedAt?: InputMaybe<DateRange>;
  id?: InputMaybe<Scalars['Int']>;
};

export enum AdjustPricingDataFieldEnum {
  All = 'All',
  BidIncrement = 'BidIncrement',
  BuyNowPrice = 'BuyNowPrice',
  StartingBidPrice = 'StartingBidPrice'
}

export enum AdjustPricingMethodEnum {
  FixedAmount = 'FixedAmount',
  Percent = 'Percent'
}

export type AdminInput = {
  auctionId: Scalars['String'];
  subjectUserId?: InputMaybe<Scalars['String']>;
};

export type AdminInputSub = {
  auctionId: Scalars['String'];
  subjectUserId: Scalars['String'];
};

export type Administrator = {
  __typename?: 'Administrator';
  allGroups?: Maybe<Array<Maybe<RoleAttributes>>>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<UserAttributes>>>;
};


export type AdministratorUserArgs = {
  input: GetSingleUserInput;
};


export type AdministratorUsersArgs = {
  input: GetUserListInput;
};

export type Agent = {
  __typename?: 'Agent';
  accountAuctionAccessNumber?: Maybe<Scalars['String']>;
  accountDisplayName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Int']>;
  accountIssuerOrgCode?: Maybe<Scalars['String']>;
  accountKey?: Maybe<Scalars['String']>;
  accountNotes?: Maybe<Array<Maybe<AccountNote>>>;
  agentAuthCode?: Maybe<Scalars['String']>;
  agentId: Scalars['Int'];
  agentNotes?: Maybe<Scalars['String']>;
  agentNumber?: Maybe<Scalars['String']>;
  attendanceHistory?: Maybe<AttendanceList>;
  auctionAccessNumber?: Maybe<Scalars['String']>;
  auctionAccessPicture?: Maybe<Scalars['String']>;
  bidderNumber?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  canBuy?: Maybe<Scalars['String']>;
  canSell?: Maybe<Scalars['String']>;
  cellPhone?: Maybe<Scalars['String']>;
  contacts?: Maybe<ContactList>;
  dateAddedOn?: Maybe<Scalars['String']>;
  dealerName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstAttendedDate?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homePhone?: Maybe<Scalars['String']>;
  lastAttendBadgeNum?: Maybe<Scalars['String']>;
  lastAttendBadgeType?: Maybe<Scalars['String']>;
  lastAttendedDate?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastPurchaseActivity?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<AgentNote>>>;
  online?: Maybe<Scalars['Boolean']>;
  otherCompanies?: Maybe<CompaniesList>;
  roles?: Maybe<Array<Maybe<AgentRole>>>;
  workPhone?: Maybe<Scalars['String']>;
};

export type AgentCompany = {
  __typename?: 'AgentCompany';
  accountDisplayName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Int']>;
  agentId?: Maybe<Scalars['Int']>;
};

export type AgentDealerResponse = {
  __typename?: 'AgentDealerResponse';
  agent?: Maybe<Agent>;
  dealer?: Maybe<Dealer>;
};

export type AgentNote = {
  __typename?: 'AgentNote';
  agentId?: Maybe<Scalars['Int']>;
  agentName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  noteText?: Maybe<Scalars['String']>;
  noteType?: Maybe<Scalars['String']>;
  sparkUser?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type AgentNoteType = {
  __typename?: 'AgentNoteType';
  code: Scalars['String'];
  id: Scalars['Int'];
  longDescription?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type AgentNoteUpdate = {
  agentId: Scalars['Int'];
  code?: InputMaybe<Scalars['String']>;
  orgCode: Scalars['String'];
  sparkUserId: Scalars['Int'];
  text?: InputMaybe<Scalars['String']>;
};

export type AgentNoteUpdateResult = {
  __typename?: 'AgentNoteUpdateResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type AgentRole = {
  __typename?: 'AgentRole';
  agentId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  longDescription?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type AgentRoleAction = {
  roleAction: Scalars['String'];
  roleCode: Scalars['String'];
};

export type AgentRoleUpdate = {
  agentId: Scalars['Int'];
  orgCode?: InputMaybe<Scalars['String']>;
  roleUpdates?: InputMaybe<Array<InputMaybe<AgentRoleAction>>>;
  sparkUserId?: InputMaybe<Scalars['Int']>;
};

export type AgentRoleUpdateResult = {
  __typename?: 'AgentRoleUpdateResult';
  roleCode?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AgentRoleUpdateResults = {
  __typename?: 'AgentRoleUpdateResults';
  results?: Maybe<Array<Maybe<AgentRoleUpdateResult>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Agents = {
  __typename?: 'Agents';
  byId?: Maybe<Agent>;
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Agent>>>;
};


export type AgentsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type AgentsFilter = {
  accountId?: InputMaybe<Scalars['Int']>;
  auctionAccessNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  orgCode?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

export type AmsCallResult = {
  __typename?: 'AmsCallResult';
  message?: Maybe<Scalars['String']>;
  operation?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AmsResponse = {
  __typename?: 'AmsResponse';
  ifNotes?: Maybe<Array<Maybe<IfOfferNotes>>>;
  stockNumber?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  announcement?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ordinal?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
  typeLongDescription?: Maybe<Scalars['String']>;
  typeShortDescription?: Maybe<Scalars['String']>;
};

export type Asset = {
  __typename?: 'Asset';
  announcements?: Maybe<Array<Maybe<Announcement>>>;
  assetFees?: Maybe<Array<Maybe<AssetFees>>>;
  assetId: Scalars['ID'];
  blackBookValue?: Maybe<Scalars['Int']>;
  bodyStyle?: Maybe<Scalars['String']>;
  buyer?: Maybe<Agent>;
  buyerAccountId?: Maybe<Scalars['Int']>;
  buyerAccountKey?: Maybe<Scalars['String']>;
  buyerAgentEmail?: Maybe<Scalars['String']>;
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerAgentName?: Maybe<Scalars['String']>;
  buyerAgentNotes?: Maybe<Scalars['String']>;
  buyerAgentPhoneMobile?: Maybe<Scalars['String']>;
  buyerAgentPicture?: Maybe<Scalars['String']>;
  buyerDisplayName?: Maybe<Scalars['String']>;
  checkinDate?: Maybe<Scalars['String']>;
  checkinTime?: Maybe<Scalars['String']>;
  checkinUser?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  conditionReport?: Maybe<ConditionReport>;
  consignor?: Maybe<Account>;
  consignorAccountId?: Maybe<Scalars['Int']>;
  consignorAccountKey?: Maybe<Scalars['String']>;
  consignorDbaName?: Maybe<Scalars['String']>;
  consignorDisplayName?: Maybe<Scalars['String']>;
  consignorId?: Maybe<Scalars['Int']>;
  consignorLegalName?: Maybe<Scalars['String']>;
  consignorPipelineId?: Maybe<Scalars['String']>;
  countAll?: Maybe<Scalars['Int']>;
  crStatus?: Maybe<Scalars['String']>;
  customerReferenceNumber?: Maybe<Scalars['String']>;
  cylinderConfiguration?: Maybe<Scalars['String']>;
  cylinders?: Maybe<Scalars['String']>;
  drivetrain?: Maybe<Scalars['String']>;
  drivetrainDesc?: Maybe<Scalars['String']>;
  engineSize?: Maybe<Scalars['String']>;
  exteriorColor?: Maybe<Scalars['String']>;
  floorAmount?: Maybe<Scalars['Int']>;
  fuelType?: Maybe<Scalars['String']>;
  grade?: Maybe<Scalars['String']>;
  hasRun?: Maybe<Scalars['Boolean']>;
  hasTitle?: Maybe<Scalars['String']>;
  ifOfferManagement?: Maybe<IfOfferManagement>;
  interiorColor?: Maybe<Scalars['String']>;
  listingCondition?: Maybe<Scalars['String']>;
  listingConditionCode?: Maybe<Scalars['String']>;
  listingConditionId?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  mmrValue?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['String']>;
  onlineListing?: Maybe<OnlineListing>;
  ownerStockNumber?: Maybe<Scalars['String']>;
  photoBeauty?: Maybe<Scalars['String']>;
  photoCount?: Maybe<Scalars['Int']>;
  photos?: Maybe<Array<Maybe<Photo>>>;
  pipelineUri?: Maybe<Scalars['String']>;
  pmrValue?: Maybe<Scalars['Int']>;
  proxyBidCount?: Maybe<Scalars['Int']>;
  saleAmount?: Maybe<Scalars['Int']>;
  saleEvents?: Maybe<Array<Maybe<SaleEvent>>>;
  saleListing?: Maybe<SaleListing>;
  saleListingDealSoldAt?: Maybe<Scalars['String']>;
  saleListingLane?: Maybe<Scalars['String']>;
  saleListingLot?: Maybe<Scalars['String']>;
  saleListingOfferCreatedAt?: Maybe<Scalars['String']>;
  saleListingSaleDate?: Maybe<Scalars['String']>;
  saleListingSaleStatus?: Maybe<Scalars['String']>;
  saleListingSoldDateLastRanTime?: Maybe<Scalars['String']>;
  saleListingVenueCode?: Maybe<Scalars['String']>;
  saleListingVenueName?: Maybe<Scalars['String']>;
  saleListingVenueUrl?: Maybe<Scalars['String']>;
  saleMethod?: Maybe<Scalars['String']>;
  sellerAgentEmail?: Maybe<Scalars['String']>;
  sellerAgentId?: Maybe<Scalars['Int']>;
  sellerAgentName?: Maybe<Scalars['String']>;
  sellerAgentPhoneMobile?: Maybe<Scalars['String']>;
  services?: Maybe<Array<Maybe<Service>>>;
  source?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  titleNumber?: Maybe<Scalars['String']>;
  titleReceivedDate?: Maybe<Scalars['String']>;
  titleState?: Maybe<Scalars['String']>;
  transmissionType?: Maybe<Scalars['String']>;
  trim?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type AssetFees = {
  __typename?: 'AssetFees';
  amount?: Maybe<Scalars['String']>;
  chargeCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  run?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
};

export type AssetFilter = {
  auctionId?: InputMaybe<Scalars['String']>;
  buyerId?: InputMaybe<Scalars['Int']>;
  buyerOrSellerAccountId?: InputMaybe<Scalars['Int']>;
  checkInDate?: InputMaybe<DateRange>;
  consigned?: InputMaybe<Scalars['Boolean']>;
  eventTypeCode?: InputMaybe<Scalars['String']>;
  hasConditionReport?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  photoCount?: InputMaybe<NumberRange>;
  purchased?: InputMaybe<Scalars['Boolean']>;
  saleDate?: InputMaybe<DateRange>;
  sellerId?: InputMaybe<Scalars['Int']>;
  sold?: InputMaybe<Scalars['Boolean']>;
  soldDate?: InputMaybe<DateRange>;
  soldOnline?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type Assets = {
  __typename?: 'Assets';
  assetsByStockNumber?: Maybe<Asset>;
  byId?: Maybe<Asset>;
  byStockNumber?: Maybe<Asset>;
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Asset>>>;
};


export type AssetsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type Attendance = {
  __typename?: 'Attendance';
  attendanceType?: Maybe<Scalars['String']>;
  bidderBadgeNumber?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
};

export type AttendanceList = {
  __typename?: 'AttendanceList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Attendance>>>;
};


export type AttendanceListListArgs = {
  days?: InputMaybe<Scalars['Int']>;
  pageInfo?: InputMaybe<PageInfo>;
};

export type Auction = {
  __typename?: 'Auction';
  accounts?: Maybe<Accounts>;
  agentNoteTypes?: Maybe<Array<Maybe<AgentNoteType>>>;
  agentRoles?: Maybe<Array<Maybe<AgentRole>>>;
  agents?: Maybe<Agents>;
  amsInfo?: Maybe<AuctionAmsInfo>;
  assets?: Maybe<Assets>;
  auctionSettings?: Maybe<AuctionSettingsResponse>;
  card?: Maybe<GenericCard>;
  contactManagement?: Maybe<ContactManagement>;
  document?: Maybe<Document>;
  getDownloadLink?: Maybe<ShareReportResponse>;
  getReportConfig?: Maybe<ReportConfig>;
  getReportConfigs?: Maybe<Array<Maybe<ReportConfig>>>;
  groups?: Maybe<Array<Maybe<AccountGroups>>>;
  keys?: Maybe<VdpByStockNumberResults>;
  lightOptions?: Maybe<Array<Maybe<LightOption>>>;
  marketplace?: Maybe<Marketplace>;
  psi?: Maybe<Psi>;
  reportDetailPages: Array<ReportDetailPage>;
  reports?: Maybe<Array<Maybe<Report>>>;
  roles?: Maybe<Array<Maybe<RoleAttributes>>>;
  search?: Maybe<SearchResults>;
  setVehicleInfo?: Maybe<SetVehicleInfoResults>;
  statistics?: Maybe<AuctionStatistics>;
  users?: Maybe<Array<Maybe<UserAttributes>>>;
};


export type AuctionAccountsArgs = {
  filter: AccountsFilter;
};


export type AuctionAgentsArgs = {
  filter: AgentsFilter;
};


export type AuctionAssetsArgs = {
  filter: AssetFilter;
};


export type AuctionAuctionSettingsArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
};


export type AuctionCardArgs = {
  filter?: InputMaybe<CardFilter>;
};


export type AuctionGetDownloadLinkArgs = {
  auctionName?: InputMaybe<Scalars['String']>;
  creationDate?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GenerateOptions>;
  reportConfigId?: InputMaybe<Scalars['String']>;
  searchFilter?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userSearchString?: InputMaybe<Scalars['String']>;
};


export type AuctionGetReportConfigArgs = {
  reportConfigId?: InputMaybe<Scalars['String']>;
};


export type AuctionGetReportConfigsArgs = {
  reportKey?: InputMaybe<Scalars['String']>;
};


export type AuctionGroupsArgs = {
  filter?: InputMaybe<AccountGroupsFilter>;
};


export type AuctionKeysArgs = {
  amsId?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
};


export type AuctionPsiArgs = {
  filter?: InputMaybe<PsiFilter>;
};


export type AuctionReportsArgs = {
  filter: ReportFilter;
};


export type AuctionSearchArgs = {
  filter?: InputMaybe<SearchFilter>;
  pageInfo?: InputMaybe<SearchPageInfo>;
  sort?: InputMaybe<SearchSort>;
};


export type AuctionSetVehicleInfoArgs = {
  amsType?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<Array<InputMaybe<SetAnnouncements>>>;
  assetId: Scalars['ID'];
  cancelProxyBids?: InputMaybe<Scalars['Boolean']>;
  expectedAnnouncements?: InputMaybe<Array<InputMaybe<ExpectedAnnouncement>>>;
  floorPrice?: InputMaybe<SetFloorPrice>;
  lights?: InputMaybe<SetLights>;
  numberOfProxyBids?: InputMaybe<Scalars['Int']>;
  stockNumber: Scalars['String'];
};


export type AuctionStatisticsArgs = {
  filter?: InputMaybe<StatisticsFilter>;
};

export type AuctionAmsInfo = {
  __typename?: 'AuctionAmsInfo';
  lightValues?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AuctionCollection = {
  __typename?: 'AuctionCollection';
  accounts?: Maybe<Accounts>;
};


export type AuctionCollectionAccountsArgs = {
  filter: AccountsFilter;
};

export type AuctionKey = {
  __typename?: 'AuctionKey';
  accountingId?: Maybe<Scalars['String']>;
  amsId?: Maybe<Scalars['String']>;
  pipelineId?: Maybe<Scalars['String']>;
  uaId?: Maybe<Scalars['String']>;
};

export type AuctionSettings = {
  __typename?: 'AuctionSettings';
  bidIncrement: Scalars['Int'];
  buyNowTiers?: Maybe<Array<Maybe<BuyNowTier>>>;
  enforceConditionReport?: Maybe<Scalars['Boolean']>;
  enforceFloorPrice?: Maybe<Scalars['Boolean']>;
  enforceGrade?: Maybe<Scalars['Boolean']>;
  enforceLight?: Maybe<Scalars['Boolean']>;
  nonAdminEditBidIncrement?: Maybe<Scalars['Boolean']>;
  nonAdminEditFloorPrice?: Maybe<Scalars['Boolean']>;
  offerThreshold: Scalars['Int'];
  startBidTiers?: Maybe<Array<Maybe<StartBidTier>>>;
};

export type AuctionSettingsInput = {
  bidIncrement: Scalars['Int'];
  buyNowTiers?: InputMaybe<Array<InputMaybe<BuyNowTierInput>>>;
  enforceConditionReport?: InputMaybe<Scalars['Boolean']>;
  enforceFloorPrice?: InputMaybe<Scalars['Boolean']>;
  enforceGrade?: InputMaybe<Scalars['Boolean']>;
  enforceLight?: InputMaybe<Scalars['Boolean']>;
  nonAdminEditBidIncrement?: InputMaybe<Scalars['Boolean']>;
  nonAdminEditFloorPrice?: InputMaybe<Scalars['Boolean']>;
  offerThreshold: Scalars['Int'];
  startBidTiers?: InputMaybe<Array<InputMaybe<StartBidTierInput>>>;
};

export type AuctionSettingsResponse = {
  __typename?: 'AuctionSettingsResponse';
  data?: Maybe<AuctionSettings>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type AuctionStatistics = {
  __typename?: 'AuctionStatistics';
  bidders?: Maybe<BidderList>;
  biddingStatistics?: Maybe<BiddingStatistics>;
  lanes?: Maybe<LaneList>;
  saleStatistics?: Maybe<SalesDayStatistics>;
  trends?: Maybe<Trends>;
  users?: Maybe<Array<Maybe<User>>>;
};


export type AuctionStatisticsBiddersArgs = {
  filter: BiddersFilter;
};


export type AuctionStatisticsTrendsArgs = {
  filter: TrendsFilter;
};

export type Audit = {
  __typename?: 'Audit';
  getVehicleAuditList?: Maybe<AuditResponse>;
};


export type AuditGetVehicleAuditListArgs = {
  input?: InputMaybe<AuditInput>;
};

export type AuditInput = {
  auctionId?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type AuditResponse = {
  __typename?: 'AuditResponse';
  data?: Maybe<Array<Maybe<TestVehicleAuditLog>>>;
  error?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export enum BallControlCode {
  Buyer = 'buyer',
  Missing = 'missing',
  Seller = 'seller'
}

export type Bidder = {
  __typename?: 'Bidder';
  accountId?: Maybe<Scalars['Int']>;
  accountKey: Scalars['String'];
  accountOrgId?: Maybe<Scalars['Int']>;
  badge: Scalars['String'];
  dbaName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  eventDate: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type BidderList = {
  __typename?: 'BidderList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Bidder>>>;
};


export type BidderListListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type BiddersFilter = {
  attendedDate?: InputMaybe<DateRange>;
};

export type BiddingStatistics = {
  __typename?: 'BiddingStatistics';
  inlaneBidders?: Maybe<Scalars['Int']>;
  onlineBidders?: Maybe<Scalars['Int']>;
  totalBidders?: Maybe<Scalars['Int']>;
};

export type BuyNowTier = {
  __typename?: 'BuyNowTier';
  amountAbovePriceFloor?: Maybe<Scalars['Int']>;
  priceFloorLBound?: Maybe<Scalars['Int']>;
  priceFloorUBound?: Maybe<Scalars['Int']>;
};

export type BuyNowTierInput = {
  amountAbovePriceFloor?: InputMaybe<Scalars['Int']>;
  priceFloorLBound?: InputMaybe<Scalars['Int']>;
  priceFloorUBound?: InputMaybe<Scalars['Int']>;
};

export type CacheShape = {
  __typename?: 'CacheShape';
  mutation?: Maybe<Mutation>;
  query?: Maybe<Query>;
};

export type CalculatedIfOfferData = {
  __typename?: 'CalculatedIfOfferData';
  buyerMovementThisOffer?: Maybe<Scalars['Int']>;
  buyerNotesThisOffer?: Maybe<Array<Maybe<Scalars['String']>>>;
  sellerMovementThisOffer?: Maybe<Scalars['Int']>;
  sellerNotesThisOffer?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CancelProxyBidsResult = {
  __typename?: 'CancelProxyBidsResult';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Scalars['Boolean'];
};

export type Card = {
  __typename?: 'Card';
  config?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type CardFilter = {
  auctionId?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export enum ColOptions {
  AllCols = 'all_cols',
  ViewCols = 'view_cols'
}

export type CompaniesList = {
  __typename?: 'CompaniesList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<AgentCompany>>>;
};


export type CompaniesListListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type ConditionReport = {
  __typename?: 'ConditionReport';
  conditionReportStatus?: Maybe<Scalars['String']>;
  conditionReportTime?: Maybe<Scalars['String']>;
  conditionReportWriter?: Maybe<Scalars['String']>;
};

export type ConfigSearchResults = {
  __typename?: 'ConfigSearchResults';
  searchStringDisplay?: Maybe<Scalars['String']>;
  vehicleData?: Maybe<Array<Maybe<VehicleDataTypes>>>;
};

export type Contact = {
  __typename?: 'Contact';
  account?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Int']>;
  agentId?: Maybe<Scalars['Int']>;
  agentName?: Maybe<Scalars['String']>;
  buyerSellerAccountId?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['String']>;
  completedBy?: Maybe<Scalars['Int']>;
  contactedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creatorFullName?: Maybe<Scalars['String']>;
  followUpDate?: Maybe<Scalars['String']>;
  followUpUserId?: Maybe<Scalars['Int']>;
  followupUserName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  /** @deprecated Use followupUserName instead */
  userName?: Maybe<Scalars['String']>;
};

export type ContactFilter = {
  accountId?: InputMaybe<Scalars['Int']>;
  agentId?: InputMaybe<Scalars['Int']>;
  forFollowUp?: InputMaybe<Scalars['Boolean']>;
  statusCode?: InputMaybe<Scalars['String']>;
};

export type ContactList = {
  __typename?: 'ContactList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Contact>>>;
};


export type ContactListListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  sortBy?: InputMaybe<ContactSortBy>;
};

export type ContactLogStats = {
  __typename?: 'ContactLogStats';
  total?: Maybe<Scalars['Int']>;
};

export type ContactManagement = {
  __typename?: 'ContactManagement';
  contacts?: Maybe<ContactList>;
  statuses?: Maybe<Array<Maybe<ContactStatus>>>;
  types?: Maybe<Array<Maybe<ContactType>>>;
};


export type ContactManagementContactsArgs = {
  filter?: InputMaybe<ContactFilter>;
};

export type ContactSortBy = {
  ascending?: InputMaybe<Scalars['Boolean']>;
  key: ContactSortKey;
};

export enum ContactSortKey {
  AgentName = 'AgentName',
  ContactedDate = 'ContactedDate',
  Status = 'Status'
}

export type ContactStatus = {
  __typename?: 'ContactStatus';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type ContactType = {
  __typename?: 'ContactType';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type CreateAgentContact = {
  agentId: Scalars['Int'];
  buyerSellerAccountId?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Scalars['Int']>;
  contactedAt: Scalars['String'];
  followUpDate?: InputMaybe<Scalars['String']>;
  followUpUserId?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  statusCode: Scalars['String'];
  typeCode: Scalars['String'];
};

export type CreateDocumentInput = {
  attachment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  docId?: InputMaybe<Scalars['String']>;
  docName?: InputMaybe<Scalars['String']>;
  docTypeId?: InputMaybe<Scalars['String']>;
  docTypeName?: InputMaybe<Scalars['String']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  transactionId: Scalars['String'];
};

export type CreateDocumentOutputAsset = {
  __typename?: 'CreateDocumentOutputAsset';
  assetId?: Maybe<Scalars['ID']>;
  attachment?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  docTypeId?: Maybe<Scalars['Int']>;
  docTypeName?: Maybe<Scalars['String']>;
  docTypeShortCode?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type CreateDocumentUploadDoc = {
  __typename?: 'CreateDocumentUploadDoc';
  assetId?: Maybe<Scalars['ID']>;
  docId?: Maybe<Scalars['String']>;
  s3PresignedUrl?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type CreateDocumentsInputAsset = {
  assetId?: InputMaybe<Scalars['ID']>;
  attachment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  docTypeId?: InputMaybe<Scalars['String']>;
  docTypeName?: InputMaybe<Scalars['String']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type CreateDocumentsUploadItem = {
  __typename?: 'CreateDocumentsUploadItem';
  asset?: Maybe<CreateDocumentOutputAsset>;
  doc?: Maybe<CreateDocumentUploadDoc>;
  error?: Maybe<Scalars['String']>;
};

export type CreateReportConfigInput = {
  PK?: InputMaybe<Scalars['String']>;
  SK?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  listViewConfig?: InputMaybe<ListViewConfigInput>;
  searchConfig?: InputMaybe<SearchConfigInput>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateReportConfigResponse = {
  __typename?: 'CreateReportConfigResponse';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type CreateUserInput = {
  admin: AdminInput;
  auctionAccessNumber?: InputMaybe<Scalars['String']>;
  authenticationUsername: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  isGlobalAdmin: Scalars['Boolean'];
  isSiteAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  mobilePhone?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Scalars['String']>;
  workPhone?: InputMaybe<Scalars['String']>;
};

export type CreateVenueEvent = {
  cancelReason?: InputMaybe<Scalars['String']>;
  eventDate: Scalars['String'];
  eventEndTime?: InputMaybe<Scalars['String']>;
  eventSettings?: InputMaybe<AuctionSettingsInput>;
  eventStartTime: Scalars['String'];
  eventTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventTitle: Scalars['String'];
  eventType: Scalars['String'];
  eventTypeDisplayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  longDescription?: InputMaybe<Scalars['String']>;
  orgCode?: InputMaybe<Scalars['String']>;
  originatingOrgCode?: InputMaybe<Scalars['String']>;
  participatingAuctions: Array<InputMaybe<Scalars['String']>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  venueCode?: InputMaybe<Scalars['String']>;
};

export type CreatedEventResponse = SparkResponse & {
  __typename?: 'CreatedEventResponse';
  data?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type CurrentSale = {
  __typename?: 'CurrentSale';
  asset_id?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  venue_event_id?: Maybe<Scalars['String']>;
  venue_event_key?: Maybe<Scalars['String']>;
};

export type CurrentSaleInput = {
  asset_id?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  venue_event_id?: InputMaybe<Scalars['String']>;
  venue_event_key?: InputMaybe<Scalars['String']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  cards?: Maybe<Array<Maybe<Card>>>;
  configJson?: Maybe<Scalars['String']>;
  databaseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DashboardCardInput = {
  config?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

export type DashboardFilter = {
  id?: InputMaybe<Scalars['String']>;
};

export type DashboardInput = {
  config?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Dashboards = {
  __typename?: 'Dashboards';
  byId?: Maybe<Dashboard>;
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Dashboard>>>;
};


export type DashboardsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type DataConfig = {
  __typename?: 'DataConfig';
  dataFilter?: Maybe<ReportSearchFilter>;
  dataSource?: Maybe<DataSourceTypes>;
  pageInfo?: Maybe<PageInfoConfig>;
};

export enum DataSourceTypes {
  Ods = 'ODS',
  Search = 'SEARCH'
}

export type DateRange = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type Deal = {
  __typename?: 'Deal';
  buyer?: Maybe<Agent>;
  currentOfferAmount?: Maybe<Scalars['Int']>;
  dealStatus?: Maybe<Scalars['String']>;
  saleListing?: Maybe<SaleListing>;
};

export type DealFilter = {
  dealId?: InputMaybe<Scalars['Int']>;
};

export type Dealer = {
  __typename?: 'Dealer';
  dealerName?: Maybe<Scalars['String']>;
};

export type DeleteAgentContact = {
  agentId: Scalars['Int'];
};

export type DeleteUserInput = {
  admin: AdminInputSub;
};

export type DocType = {
  __typename?: 'DocType';
  displayOrder: Scalars['Int'];
  docTypeId: Scalars['String'];
  docTypeName: Scalars['String'];
  docTypeNameUnderscored?: Maybe<Scalars['String']>;
  shortCode: Scalars['String'];
  verticalTypeId: Scalars['String'];
};

export type Document = {
  __typename?: 'Document';
  accountId?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
  buyerAccount?: Maybe<Account>;
  buyerAccountKey?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdAtFormatted: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  currentSaleListingDate?: Maybe<Scalars['String']>;
  customerAccountKey?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Int']>;
  displayOrder: Scalars['Int'];
  docId: Scalars['ID'];
  docName?: Maybe<Scalars['String']>;
  docTypeId: Scalars['String'];
  docTypeName: Scalars['String'];
  docTypeNameUnderscored?: Maybe<Scalars['String']>;
  docTypeShortCode?: Maybe<Scalars['String']>;
  documentActivity?: Maybe<DocumentActivity>;
  documentByDocId?: Maybe<Document>;
  documentByDocTypeShortCode?: Maybe<Array<Maybe<Document>>>;
  documentFilterLists?: Maybe<Array<Maybe<Document>>>;
  documentLists?: Maybe<Array<Maybe<Document>>>;
  documentTypes?: Maybe<Array<Maybe<DocType>>>;
  /** @deprecated Will be inside other call */
  documentUploadURLs?: Maybe<Array<Maybe<DocumentUploadUrl>>>;
  documentsByAuctionFilter?: Maybe<PaginatedDocumentResponse>;
  numNotes?: Maybe<Scalars['Int']>;
  s3Url?: Maybe<Scalars['String']>;
  s3UrlDownload?: Maybe<Scalars['String']>;
  s3UrlExpires?: Maybe<Scalars['String']>;
  s3UrlExpiresFormatted?: Maybe<Scalars['String']>;
  sellerAccount?: Maybe<Account>;
  stockNumber?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedAtFormatted?: Maybe<Scalars['String']>;
  vehicleMake?: Maybe<Scalars['String']>;
  vehicleModel?: Maybe<Scalars['String']>;
  vehicleVIN?: Maybe<Scalars['String']>;
  vehicleYear?: Maybe<Scalars['String']>;
  vehiclesWithDocs?: Maybe<VehiclesWithDocsResponse>;
};


export type DocumentDocumentActivityArgs = {
  docId: Scalars['String'];
};


export type DocumentDocumentByDocIdArgs = {
  filter: DocumentsFilter;
};


export type DocumentDocumentByDocTypeShortCodeArgs = {
  filter: DocumentsFilter;
};


export type DocumentDocumentFilterListsArgs = {
  filter: DocumentsFilter;
};


export type DocumentDocumentListsArgs = {
  filter: DocumentsFilter;
};


export type DocumentDocumentTypesArgs = {
  verticalTypeId: Scalars['String'];
};


export type DocumentDocumentUploadUrLsArgs = {
  filter: DocumentUploadUrLsFilter;
};


export type DocumentDocumentsByAuctionFilterArgs = {
  filter: DocumentsFilter;
};


export type DocumentVehiclesWithDocsArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
};

export type DocumentActivity = {
  __typename?: 'DocumentActivity';
  documentViews?: Maybe<Array<Maybe<DocumentView>>>;
};

export type DocumentUploadUrl = {
  __typename?: 'DocumentUploadURL';
  customerId: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  s3Key: Scalars['String'];
  s3uploadUrl: Scalars['String'];
  tenantId: Scalars['String'];
  urlExpires: Scalars['String'];
};

export type DocumentUploadUrLsFilter = {
  accountId?: InputMaybe<Scalars['Int']>;
  consignorAccountKey?: InputMaybe<Scalars['String']>;
  fileType: Scalars['String'];
  numFiles: Scalars['Int'];
};

export type DocumentView = {
  __typename?: 'DocumentView';
  docId: Scalars['String'];
  userDisplay?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userType?: Maybe<User_Types>;
  viewedAt: Scalars['Int'];
};

export type DocumentsFilter = {
  accountId?: InputMaybe<Scalars['Int']>;
  amsId?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['ID']>;
  buyerId?: InputMaybe<Scalars['String']>;
  currentSaleListingDate?: InputMaybe<Scalars['String']>;
  currentSaleListingEndDate?: InputMaybe<Scalars['String']>;
  currentSaleListingStartDate?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  dateStamp?: InputMaybe<Scalars['String']>;
  docId?: InputMaybe<Scalars['String']>;
  docTypeName?: InputMaybe<Scalars['String']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  pageInfo?: InputMaybe<PageInfo>;
  stockNumber?: InputMaybe<Scalars['String']>;
};

export enum EventStatusesEnum {
  Active = 'Active',
  All = 'All',
  Canceled = 'Canceled',
  Ended = 'Ended',
  Future = 'Future',
  Paused = 'Paused'
}

export enum EventTriggerCode {
  Accepted = 'accepted',
  AcceptedBuyer = 'accepted_buyer',
  AcceptedSeller = 'accepted_seller',
  CounterBuyer = 'counter_buyer',
  CounterSeller = 'counter_seller',
  Note = 'note',
  NoteBuyer = 'note_buyer',
  NoteSeller = 'note_seller',
  RejectedBuyer = 'rejected_buyer',
  RejectedSeller = 'rejected_seller',
  System = 'system'
}

export enum EventTypeCode {
  Aborted = 'aborted',
  Completed = 'completed',
  EmailReceiptReceipt = 'email_receipt_receipt',
  EmailSent = 'email_sent',
  NoteAdded = 'note_added',
  OfferChange = 'offer_change',
  Pending = 'pending',
  SmsSent = 'sms_sent',
  Start = 'start'
}

export type EventTypeTrigger = {
  __typename?: 'EventTypeTrigger';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  longDescription?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export enum EventTypesEnum {
  Live = 'live',
  Timed = 'timed'
}

export type EventsListFilter = {
  endDate?: InputMaybe<Scalars['String']>;
  eventStatuses?: InputMaybe<Array<InputMaybe<EventStatusesEnum>>>;
  eventType?: InputMaybe<EventTypesEnum>;
  startDate?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ExitVehicleRequest = {
  exitStatus: Scalars['String'];
  orgCode?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['Int'];
  vin: Scalars['String'];
};

export type ExpectedAnnouncement = {
  announcement: Scalars['String'];
  ordinal: Scalars['Int'];
};

export type FullSearch = {
  displayName: Scalars['String'];
  filterName: Scalars['String'];
  searchName: Scalars['String'];
};

export enum GenerateFormats {
  Csv = 'csv',
  Json = 'json',
  Pdf = 'pdf'
}

export type GenerateOptions = {
  colOptions?: InputMaybe<ColOptions>;
};

export type GeneratePdfInput = {
  auctionId?: InputMaybe<Scalars['String']>;
  auctionName?: InputMaybe<Scalars['String']>;
  creationDate?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<GenerateFormats>;
  message?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GenerateOptions>;
  putMessage?: InputMaybe<MessageInput>;
  reportConfigId?: InputMaybe<Scalars['String']>;
  searchFilter?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userSearchString?: InputMaybe<Scalars['String']>;
};

export type GenericCard = {
  __typename?: 'GenericCard';
  vdpViewsCount?: Maybe<Scalars['Int']>;
  vdpViewsStats?: Maybe<Array<Maybe<OnlineStatistic>>>;
  watchedVehiclesCount?: Maybe<Scalars['Int']>;
  watchedVehiclesList?: Maybe<Array<Maybe<OnlineListing>>>;
};

export type GetSingleUserInput = {
  admin: AdminInputSub;
};

export type GetUserListInput = {
  admin: AdminInput;
};

export type HttpResponse = {
  __typename?: 'HttpResponse';
  statusCode: Scalars['Int'];
  statusMessage?: Maybe<Scalars['String']>;
};

export type IfOfferDetails = {
  assetId?: InputMaybe<Scalars['ID']>;
  buyerAgentId?: InputMaybe<Scalars['Int']>;
  eventTriggerCode?: InputMaybe<EventTriggerCode>;
  eventTypeCode?: InputMaybe<EventTypeCode>;
  isVisible?: InputMaybe<Scalars['Int']>;
  offerAmount?: InputMaybe<Scalars['Int']>;
  offerNote?: InputMaybe<Scalars['String']>;
  orgCode?: InputMaybe<Scalars['String']>;
  sellerAgentId?: InputMaybe<Scalars['Int']>;
  sparkUserId?: InputMaybe<Scalars['Int']>;
};

export type IfOfferFilter = {
  assetId?: InputMaybe<Scalars['ID']>;
  pastHistory?: InputMaybe<Scalars['Boolean']>;
};

export type IfOfferHistory = {
  __typename?: 'IfOfferHistory';
  announcementLight?: Maybe<Scalars['String']>;
  announcementLights?: Maybe<Scalars['String']>;
  assetAnnouncementFour?: Maybe<Scalars['String']>;
  assetAnnouncementOne?: Maybe<Scalars['String']>;
  assetAnnouncementThree?: Maybe<Scalars['String']>;
  assetAnnouncementTwo?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  ballControlCode?: Maybe<BallControlCode>;
  ballControlDescription?: Maybe<Scalars['String']>;
  buyNowPrice?: Maybe<Scalars['Int']>;
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerAgentName?: Maybe<Scalars['String']>;
  buyerDisplayName?: Maybe<Scalars['String']>;
  buyerOrSellerAccountId?: Maybe<Scalars['Int']>;
  correlationId?: Maybe<Scalars['String']>;
  currentOfferAmount?: Maybe<Scalars['Int']>;
  currentOfferAmountPrevious?: Maybe<Scalars['Int']>;
  dealId?: Maybe<Scalars['Int']>;
  dealStatusCode?: Maybe<Scalars['String']>;
  eventCreatedAt?: Maybe<Scalars['String']>;
  eventCreatedBy?: Maybe<Scalars['String']>;
  eventCreatedById?: Maybe<Scalars['Int']>;
  eventDate?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['Int']>;
  eventNote?: Maybe<Scalars['String']>;
  eventTriggerCode?: Maybe<EventTriggerCode>;
  eventTriggerDesc?: Maybe<Scalars['String']>;
  eventTypeCode?: Maybe<EventTypeCode>;
  eventTypeDesc?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['Int']>;
  floorPrice?: Maybe<Scalars['Int']>;
  isVirtualAuction?: Maybe<Scalars['Boolean']>;
  laneName?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  saleListingId?: Maybe<Scalars['Int']>;
  sellerAgentId?: Maybe<Scalars['Int']>;
  sellerAgentName?: Maybe<Scalars['String']>;
  valuationBlackbookAmount?: Maybe<Scalars['Int']>;
  valuationMMRAmount?: Maybe<Scalars['Int']>;
};

export type IfOfferManagement = {
  __typename?: 'IfOfferManagement';
  buyerAgent?: Maybe<Agent>;
  buyerAgents?: Maybe<Array<Maybe<Agent>>>;
  calculatedIfOfferData?: Maybe<CalculatedIfOfferData>;
  eventTriggers?: Maybe<Array<Maybe<EventTypeTrigger>>>;
  eventTypes?: Maybe<Array<Maybe<EventTypeTrigger>>>;
  ifOfferHistory?: Maybe<Array<Maybe<IfOfferHistory>>>;
  noSaleHistory?: Maybe<Array<Maybe<NoSaleHistory>>>;
  pastSalesHistory?: Maybe<Array<Maybe<PastSale>>>;
  sellerAgent?: Maybe<Agent>;
  sellerAgents?: Maybe<Array<Maybe<Agent>>>;
};

export enum IfOfferNoteType {
  Buyer = 'buyer',
  General = 'general',
  Seller = 'seller'
}

export type IfOfferNotes = {
  __typename?: 'IfOfferNotes';
  date: Scalars['String'];
  note: Scalars['String'];
  type: IfOfferNoteType;
  user: Scalars['String'];
};

export type IfOfferUpdateAmsResponse = {
  __typename?: 'IfOfferUpdateAMSResponse';
  data?: Maybe<AmsResponse>;
  messages?: Maybe<AmsUpdateResponseMessages>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type IfOfferUpdateResult = {
  __typename?: 'IfOfferUpdateResult';
  amsStatusCode?: Maybe<Scalars['Int']>;
  amsStatusText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  ifNotes?: Maybe<Array<Maybe<IfOfferNotes>>>;
  lastOfferHistoryItem?: Maybe<IfOfferHistory>;
  stockNumber?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  vin?: Maybe<Scalars['String']>;
};

export type IfOfferUpdateResults = {
  __typename?: 'IfOfferUpdateResults';
  results?: Maybe<Array<Maybe<IfOfferUpdateResult>>>;
  searchUpdateSuccess?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type InspectionInput = {
  assetId: Scalars['ID'];
  canPrint?: InputMaybe<Scalars['Boolean']>;
  feeAmount: Scalars['Int'];
  isOverridden?: InputMaybe<Scalars['Boolean']>;
  printer?: InputMaybe<Scalars['String']>;
  serviceClass: Scalars['String'];
  serviceCode: Scalars['String'];
  serviceCodeDescription: Scalars['String'];
  serviceNote?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['String'];
  vin: Scalars['String'];
};

export type InspectionType = {
  __typename?: 'InspectionType';
  chargeAmount: Scalars['Float'];
  chargeAmountFail?: Maybe<Scalars['Float']>;
  chargeCode?: Maybe<Scalars['String']>;
  defaultPrinterName?: Maybe<Scalars['String']>;
  longDesc: Scalars['String'];
  ordinal: Scalars['Int'];
  orgId: Scalars['Int'];
  printOnCreate?: Maybe<Scalars['Int']>;
  quickPickLabel?: Maybe<Scalars['String']>;
  quickPickOrdinal: Scalars['Int'];
  serviceClass: Scalars['String'];
  serviceCode: Scalars['String'];
  shortDesc: Scalars['String'];
};

export type InspectionTypeFilter = {
  __typename?: 'InspectionTypeFilter';
  amsServiceCode?: Maybe<Scalars['String']>;
  chargeAmount?: Maybe<Scalars['Int']>;
  orgCode: Scalars['String'];
  serviceProductId?: Maybe<Scalars['Int']>;
};

export type Lane = {
  __typename?: 'Lane';
  arbitration?: Maybe<Scalars['Int']>;
  eventDate?: Maybe<Scalars['String']>;
  hasCr?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  offer?: Maybe<Scalars['Int']>;
  offerOnline?: Maybe<Scalars['Int']>;
  registered?: Maybe<Scalars['Int']>;
  run?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  soldOnline?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
};

export type LaneList = {
  __typename?: 'LaneList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Lane>>>;
};


export type LaneListListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type LightOption = {
  __typename?: 'LightOption';
  amsValue?: Maybe<Scalars['String']>;
  lightCode?: Maybe<Scalars['String']>;
  lightDescription?: Maybe<Scalars['String']>;
  lightId?: Maybe<Scalars['Int']>;
};

export type ListView = {
  __typename?: 'ListView';
  columns?: Maybe<Array<Maybe<ReportColumn>>>;
  mobileColumns?: Maybe<Array<Maybe<ReportColumn>>>;
  paths?: Maybe<PathConfig>;
  shareSubject?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  templateVars?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export type ListViewConfigInput = {
  columns?: InputMaybe<Array<InputMaybe<ReportColumnInput>>>;
  mobileColumns?: InputMaybe<Array<InputMaybe<ReportColumnInput>>>;
  paths?: InputMaybe<PathConfigInput>;
  shareSubject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type LocalCreateDocumentInput = {
  assetId: Scalars['String'];
  customerId: Scalars['String'];
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  s3Key: Scalars['String'];
  stockNumber?: InputMaybe<Scalars['String']>;
};

export type LocalCreateDocumentOutput = {
  __typename?: 'LocalCreateDocumentOutput';
  docId: Scalars['String'];
};

export type LocalUploadDocumentInput = {
  assetId?: InputMaybe<Scalars['ID']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  stockNumber?: InputMaybe<Scalars['Int']>;
};

export type Location = {
  __typename?: 'Location';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LoginCredentials = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  message?: Maybe<Scalars['String']>;
  result: LoginResponseTypes;
};

export enum LoginResponseTypes {
  Failure = 'FAILURE',
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  Success = 'SUCCESS'
}

export type MaintenanceDetails = {
  endsAt?: InputMaybe<Scalars['String']>;
  isMaintenanceModeActive: Scalars['Boolean'];
  isPartialMaintenance?: InputMaybe<Scalars['Boolean']>;
  isScheduled?: InputMaybe<Scalars['Boolean']>;
  startsAt?: InputMaybe<Scalars['String']>;
  statusMessage?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MaintenanceUpdateResult = {
  __typename?: 'MaintenanceUpdateResult';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Marketplace = {
  __typename?: 'Marketplace';
  listings?: Maybe<OnlineListings>;
  statistics?: Maybe<MarketplaceStatistics>;
};


export type MarketplaceListingsArgs = {
  filter?: InputMaybe<OnlineListingFilter>;
};

export type MarketplaceStatistics = {
  __typename?: 'MarketplaceStatistics';
  activeListings?: Maybe<Scalars['Int']>;
  soldOnline?: Maybe<Scalars['Int']>;
  viewed?: Maybe<Scalars['Int']>;
  viewedByDate?: Maybe<Array<Maybe<OnlineStatistic>>>;
  watched?: Maybe<Scalars['Int']>;
};


export type MarketplaceStatisticsViewedArgs = {
  dates?: InputMaybe<DateRange>;
};


export type MarketplaceStatisticsViewedByDateArgs = {
  dates?: InputMaybe<DateRange>;
};

export type MessageInput = {
  context?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName: Scalars['String'];
  displayUrl?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  messageBody?: InputMaybe<Scalars['String']>;
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
  smsNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stockNumber?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  textHeader?: InputMaybe<Scalars['String']>;
};

export type MutateAccountGroupFilter = {
  accountGroupId?: InputMaybe<Scalars['Int']>;
  accountKey?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAssetsToVenueEvent?: Maybe<Array<Maybe<MutationResponse>>>;
  addDashboardCard?: Maybe<Scalars['Boolean']>;
  addPastSearch?: Maybe<Scalars['Boolean']>;
  /** @deprecated Moving to `createDocuments`. */
  batchCreateDocument?: Maybe<Array<Maybe<Document>>>;
  beginEditingLayouts: Scalars['Boolean'];
  changeAuction?: Maybe<Scalars['Boolean']>;
  changeDashboardName?: Maybe<Scalars['Boolean']>;
  closeAccessoryDrawer?: Maybe<Scalars['Boolean']>;
  copyDashboard?: Maybe<Scalars['Boolean']>;
  copyDashboardCard?: Maybe<Scalars['Boolean']>;
  createAgentContact?: Maybe<Contact>;
  createDashboard?: Maybe<Scalars['Boolean']>;
  createDocuments?: Maybe<Array<Maybe<CreateDocumentsUploadItem>>>;
  createDocumentsClient?: Maybe<Array<Maybe<LocalCreateDocumentOutput>>>;
  createPSI?: Maybe<OpenPsiResponse>;
  createReportConfig?: Maybe<CreateReportConfigResponse>;
  createUser?: Maybe<UserMutationResponse>;
  createVenueEvent?: Maybe<CreatedEventResponse>;
  deleteAgentContact?: Maybe<Scalars['Boolean']>;
  deleteDashboard?: Maybe<Scalars['Boolean']>;
  deleteDashboardCard?: Maybe<Scalars['Boolean']>;
  deleteUser?: Maybe<UserMutationResponse>;
  deleteVenueEvent?: Maybe<MutationResponse>;
  doCompleteNewPassword?: Maybe<LoginResponse>;
  doLogin?: Maybe<LoginResponse>;
  doLogout?: Maybe<Scalars['Boolean']>;
  doResetPasswordByEmail?: Maybe<ResetPasswordByEmailResponse>;
  endEditingLayouts: Scalars['Boolean'];
  exitVehicle?: Maybe<VehicleAmsResponse>;
  generatePDF?: Maybe<ShareReportResponse>;
  generateUploadUrl: DocumentUploadUrl;
  noSale?: Maybe<VehicleAmsResponse>;
  pullVehicle?: Maybe<VehicleAmsResponse>;
  pushToAMS?: Maybe<PushToAmsResponse>;
  pushVehicleToAms?: Maybe<PushVehicleToAmsResults>;
  pushVehiclesToAms?: Maybe<PushVehiclesToAmsResults>;
  putMessage?: Maybe<SendMessageStatus>;
  registerBidder?: Maybe<RegisterBidderResponse>;
  removeAssetFromVenueEvent?: Maybe<MutationResponse>;
  removeAssetsFromVenueEvent?: Maybe<Array<Maybe<MutationResponse>>>;
  removeDocument?: Maybe<Document>;
  reorderUserDashboards?: Maybe<Scalars['Boolean']>;
  resendUnconfirmedPassword?: Maybe<HttpResponse>;
  resetPasswordByEmail?: Maybe<ResetPasswordByEmailResponse>;
  reverseSale?: Maybe<VehicleAmsResponse>;
  saveLayouts?: Maybe<Scalars['Boolean']>;
  setVehicleInfo?: Maybe<SetVehicleInfoResults>;
  sharePdfCsv: Scalars['Boolean'];
  showAccessoryDrawer?: Maybe<Scalars['Boolean']>;
  tempSaveLayouts?: Maybe<Scalars['Boolean']>;
  updateAgentContact?: Maybe<Contact>;
  updateAgentNote?: Maybe<AgentNoteUpdateResult>;
  updateAgentRoles?: Maybe<AgentRoleUpdateResults>;
  updateAllAssetsOnVenueEvent?: Maybe<UpateAllListingsMutationResponse>;
  updateAssetOnVenueEvent?: Maybe<MutationResponse>;
  updateAssetsOnVenueEvent?: Maybe<Array<Maybe<MutationResponse>>>;
  updateAuctionSettings?: Maybe<AuctionSettingsResponse>;
  updateBIRoles?: Maybe<HttpResponse>;
  updateDashboardCard?: Maybe<Scalars['Boolean']>;
  updateDocTypeShortCode?: Maybe<UpdateDocumentsResponse>;
  updateDocument?: Maybe<Document>;
  updateDocuments?: Maybe<UpdateDocumentsResponse>;
  updateFavoriteAccount?: Maybe<HttpResponse>;
  updateIfOffer?: Maybe<IfOfferUpdateResults>;
  updateMaintenanceStatus?: Maybe<MaintenanceUpdateResult>;
  updateMultipleIfOffers?: Maybe<IfOfferUpdateResults>;
  updateRoles?: Maybe<HttpResponse>;
  updateTenantIdAndCreatedAt?: Maybe<UpdateDocumentsResponse>;
  updateUser?: Maybe<UserMutationResponse>;
  updateVenueEvent?: Maybe<CreatedEventResponse>;
  uploadDocument?: Maybe<Scalars['Boolean']>;
  uploadDocuments?: Maybe<Scalars['Boolean']>;
};


export type MutationAddAssetsToVenueEventArgs = {
  assets?: InputMaybe<Array<InputMaybe<VenueSaleListingAssetInput>>>;
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};


export type MutationAddDashboardCardArgs = {
  card: Scalars['String'];
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationAddPastSearchArgs = {
  input: FullSearch;
};


export type MutationBatchCreateDocumentArgs = {
  createDocumentInput: Array<InputMaybe<CreateDocumentInput>>;
};


export type MutationChangeAuctionArgs = {
  newAuction: Scalars['String'];
};


export type MutationChangeDashboardNameArgs = {
  dashId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCopyDashboardArgs = {
  name: Scalars['String'];
  priorDashId?: InputMaybe<Scalars['String']>;
  priorUserId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCopyDashboardCardArgs = {
  dashId?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['String']>;
  priorDashId?: InputMaybe<Scalars['String']>;
  priorUserId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  widgetId: Scalars['String'];
};


export type MutationCreateAgentContactArgs = {
  input: CreateAgentContact;
};


export type MutationCreateDashboardArgs = {
  name: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateDocumentsArgs = {
  assets?: InputMaybe<Array<InputMaybe<CreateDocumentsInputAsset>>>;
  auctionId: Scalars['String'];
};


export type MutationCreateDocumentsClientArgs = {
  docs: Array<LocalCreateDocumentInput>;
};


export type MutationCreatePsiArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<Array<InputMaybe<InspectionInput>>>;
};


export type MutationCreateReportConfigArgs = {
  input?: InputMaybe<CreateReportConfigInput>;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  newVenueEvent?: InputMaybe<CreateVenueEvent>;
};


export type MutationDeleteAgentContactArgs = {
  id: Scalars['Int'];
  input: DeleteAgentContact;
};


export type MutationDeleteDashboardArgs = {
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteDashboardCardArgs = {
  cardId: Scalars['String'];
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationDoCompleteNewPasswordArgs = {
  newPassword: Scalars['String'];
};


export type MutationDoLoginArgs = {
  credentials: LoginCredentials;
};


export type MutationDoResetPasswordByEmailArgs = {
  email: Scalars['String'];
};


export type MutationExitVehicleArgs = {
  exitVehicleDetails: ExitVehicleRequest;
};


export type MutationGeneratePdfArgs = {
  input?: InputMaybe<GeneratePdfInput>;
};


export type MutationGenerateUploadUrlArgs = {
  assetId: Scalars['ID'];
};


export type MutationNoSaleArgs = {
  noSaleDetails: NoSaleRequest;
};


export type MutationPullVehicleArgs = {
  pullVehicleDetails: PullVehicleRequest;
};


export type MutationPushToAmsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationPushVehicleToAmsArgs = {
  id: Scalars['ID'];
};


export type MutationPushVehiclesToAmsArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationPutMessageArgs = {
  input?: InputMaybe<MessageInput>;
};


export type MutationRegisterBidderArgs = {
  bidderDetails: RegisterBidderDetails;
};


export type MutationRemoveAssetFromVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  venueAssetId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveAssetsFromVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  venueAssetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationRemoveDocumentArgs = {
  docId: Scalars['String'];
};


export type MutationReorderUserDashboardsArgs = {
  id: Scalars['String'];
  index: Scalars['Int'];
};


export type MutationResendUnconfirmedPasswordArgs = {
  input: ResendUnconfirmedPasswordInput;
};


export type MutationResetPasswordByEmailArgs = {
  input: ResetPasswordByEmailInput;
};


export type MutationReverseSaleArgs = {
  reverseSaleDetails: ReverseSaleRequest;
};


export type MutationSaveLayoutsArgs = {
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationSetVehicleInfoArgs = {
  amsType: Scalars['String'];
  announcements?: InputMaybe<Array<InputMaybe<SetAnnouncements>>>;
  assetId: Scalars['ID'];
  cancelProxyBids?: InputMaybe<Scalars['Boolean']>;
  expectedAnnouncements?: InputMaybe<Array<InputMaybe<ExpectedAnnouncement>>>;
  floor: Scalars['Int'];
  numberOfProxyBids?: InputMaybe<Scalars['Int']>;
  selectedLightId: Scalars['Int'];
  stockNumber: Scalars['String'];
};


export type MutationSharePdfCsvArgs = {
  displayName?: InputMaybe<Scalars['String']>;
  displayUrl?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  messageBody: Scalars['String'];
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
  smsNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subject?: InputMaybe<Scalars['String']>;
  textHeader?: InputMaybe<Scalars['String']>;
};


export type MutationShowAccessoryDrawerArgs = {
  input: AccessoryDrawerDisplay;
};


export type MutationTempSaveLayoutsArgs = {
  layouts: Scalars['String'];
};


export type MutationUpdateAgentContactArgs = {
  id: Scalars['Int'];
  input: UpdateAgentContact;
};


export type MutationUpdateAgentNoteArgs = {
  agentNoteUpdate?: InputMaybe<AgentNoteUpdate>;
};


export type MutationUpdateAgentRolesArgs = {
  agentRoleUpdate?: InputMaybe<AgentRoleUpdate>;
};


export type MutationUpdateAllAssetsOnVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  updateMethods?: InputMaybe<Array<InputMaybe<UpdateAllVenueAssets>>>;
};


export type MutationUpdateAssetOnVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  venueSaleListing?: InputMaybe<VenueSaleListingAssetInput>;
};


export type MutationUpdateAssetsOnVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  venueSaleListings?: InputMaybe<Array<InputMaybe<VenueSaleListingAssetInput>>>;
};


export type MutationUpdateAuctionSettingsArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  auctionSettingsInput?: InputMaybe<AuctionSettingsInput>;
};


export type MutationUpdateBiRolesArgs = {
  orgCode?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Scalars['String']>;
  subjectUserId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDashboardCardArgs = {
  card: Scalars['String'];
  cardId: Scalars['String'];
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDocTypeShortCodeArgs = {
  tenantId: Scalars['String'];
};


export type MutationUpdateDocumentArgs = {
  updateDocumentInput: UpdateDocumentInput;
};


export type MutationUpdateDocumentsArgs = {
  tenantId: Scalars['String'];
};


export type MutationUpdateFavoriteAccountArgs = {
  input?: InputMaybe<UpdateFavoritesInput>;
};


export type MutationUpdateIfOfferArgs = {
  ifOfferDetails?: InputMaybe<IfOfferDetails>;
};


export type MutationUpdateMaintenanceStatusArgs = {
  maintenanceDetails?: InputMaybe<MaintenanceDetails>;
};


export type MutationUpdateMultipleIfOffersArgs = {
  ifOfferDetails?: InputMaybe<Array<InputMaybe<IfOfferDetails>>>;
};


export type MutationUpdateRolesArgs = {
  input: UpdateRoles;
};


export type MutationUpdateTenantIdAndCreatedAtArgs = {
  tenantId: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  newVenueEvent?: InputMaybe<CreateVenueEvent>;
};


export type MutationUploadDocumentArgs = {
  input: LocalUploadDocumentInput;
};


export type MutationUploadDocumentsArgs = {
  docs: Array<LocalUploadDocumentInput>;
};

export type MutationDataResponse = VenueEvent | VenueSaleListingAsset;

export type MutationResponse = SparkResponse & {
  __typename?: 'MutationResponse';
  data?: Maybe<MutationDataResponse>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type NoSaleHistory = {
  __typename?: 'NoSaleHistory';
  eventDate?: Maybe<Scalars['String']>;
  hasRun?: Maybe<Scalars['Boolean']>;
  highBid?: Maybe<Scalars['Int']>;
  lane?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
};

export type NoSaleRequest = {
  floorPrice?: InputMaybe<Scalars['Float']>;
  noSaleFlag: Scalars['Boolean'];
  orgCode?: InputMaybe<Scalars['String']>;
  saleDate?: InputMaybe<Scalars['String']>;
  salePrice?: InputMaybe<Scalars['Float']>;
  stockNumber: Scalars['Int'];
  vin: Scalars['String'];
};

export type NumberRange = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

export type OnlineListing = {
  __typename?: 'OnlineListing';
  assetId?: Maybe<Scalars['ID']>;
  make?: Maybe<Scalars['String']>;
  mmrValuation?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  vdpUri?: Maybe<Scalars['String']>;
  watchCount?: Maybe<Scalars['Int']>;
  watchers?: Maybe<Array<Maybe<Watcher>>>;
  webViews?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['String']>;
};

export type OnlineListingFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  saleDate?: InputMaybe<DateRange>;
  sold?: InputMaybe<Scalars['Boolean']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
  watched?: InputMaybe<Scalars['Boolean']>;
};

export type OnlineListings = {
  __typename?: 'OnlineListings';
  byAssetId?: Maybe<OnlineListing>;
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<OnlineListing>>>;
};


export type OnlineListingsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type OnlineStatistic = {
  __typename?: 'OnlineStatistic';
  count: Scalars['Int'];
  date: Scalars['String'];
};

export type OpenPsiResponse = {
  __typename?: 'OpenPsiResponse';
  message?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
  serviceResponses?: Maybe<Array<Maybe<ServiceResponse>>>;
};

export type Organization = {
  __typename?: 'Organization';
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  groupOrgId?: Maybe<Scalars['Int']>;
  isAEAdmin?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isAuctionUser?: Maybe<Scalars['Boolean']>;
  isCorporateGroupUser?: Maybe<Scalars['Boolean']>;
  lastUpdated?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  orgNumber?: Maybe<Scalars['Int']>;
  orgTypeCode?: Maybe<Scalars['String']>;
  sites?: Maybe<Array<Maybe<Site>>>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type OrganizationInput = {
  isAdmin: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  orgId: Scalars['String'];
};

export type PageInfo = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PageInfoConfig = {
  __typename?: 'PageInfoConfig';
  csvMaxRows?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  overRidePageLimit?: Maybe<Scalars['Boolean']>;
  sortColumns?: Maybe<Array<Maybe<SortColumn>>>;
};

export type PageInfoConfigInput = {
  csvMaxRows?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  overRidePageLimit?: InputMaybe<Scalars['Boolean']>;
  sortColumns?: InputMaybe<Array<InputMaybe<SortColumnInput>>>;
};

export type PaginatedDocumentResponse = {
  __typename?: 'PaginatedDocumentResponse';
  itemCount?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<Document>>>;
  nextToken?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginationControls = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};

export type PastSale = {
  __typename?: 'PastSale';
  assetId?: Maybe<Scalars['ID']>;
  buyerAccountId?: Maybe<Scalars['Int']>;
  buyerDisplayName?: Maybe<Scalars['String']>;
  closedDate?: Maybe<Scalars['String']>;
  dealHistory?: Maybe<Array<Maybe<IfOfferHistory>>>;
  dealId?: Maybe<Scalars['Int']>;
  dealOutcome?: Maybe<Scalars['String']>;
  dealStatus?: Maybe<Scalars['String']>;
  eventClassCode?: Maybe<Scalars['String']>;
  eventClassName?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['String']>;
  hasRun?: Maybe<Scalars['Boolean']>;
  highBid?: Maybe<Scalars['Int']>;
  lane?: Maybe<Scalars['String']>;
  lastCounter?: Maybe<Scalars['Int']>;
  lastCounterBy?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  noSold?: Maybe<Scalars['Boolean']>;
  rejectedBy?: Maybe<Scalars['String']>;
  saleListingId?: Maybe<Scalars['Int']>;
  soldAmount?: Maybe<Scalars['Int']>;
  venueCode?: Maybe<Scalars['String']>;
  venueEventTitle?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
};

export type PastSearch = {
  __typename?: 'PastSearch';
  displayName?: Maybe<Scalars['String']>;
  filterName?: Maybe<Scalars['String']>;
  searchName?: Maybe<Scalars['String']>;
};

export type PathConfig = {
  __typename?: 'PathConfig';
  countPath?: Maybe<Scalars['String']>;
  listPath?: Maybe<Scalars['String']>;
};

export type PathConfigInput = {
  countPath?: InputMaybe<Scalars['String']>;
  listPath?: InputMaybe<Scalars['String']>;
};

export type PdfColumn = {
  Header?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type PdfRow = {
  account?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<Scalars['String']>;
};

export enum PendingSuccess {
  False = 'FALSE',
  Pending = 'PENDING',
  True = 'TRUE'
}

export type PermissionItem = {
  __typename?: 'PermissionItem';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type Photo = {
  __typename?: 'Photo';
  fileName?: Maybe<Scalars['String']>;
  hiresUrl?: Maybe<Scalars['String']>;
  imageUri_60x50?: Maybe<Scalars['String']>;
  imageUri_70x53?: Maybe<Scalars['String']>;
  imageUri_100x75?: Maybe<Scalars['String']>;
  imageUri_200x150?: Maybe<Scalars['String']>;
  imageUri_220x165?: Maybe<Scalars['String']>;
  imageUri_300x231?: Maybe<Scalars['String']>;
  imageUri_320x240?: Maybe<Scalars['String']>;
  imageUri_400x300?: Maybe<Scalars['String']>;
  imageUri_480x360?: Maybe<Scalars['String']>;
  imageUri_480x480?: Maybe<Scalars['String']>;
  imageUri_640x480?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  pipelineUri?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  standardUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  authenticationId: Scalars['String'];
  dashboards?: Maybe<Array<Scalars['String']>>;
  databaseId: Scalars['Int'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  mobilePhone?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  roles?: Maybe<Array<RoleAttributes>>;
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type Psi = {
  __typename?: 'Psi';
  inspectionTypes?: Maybe<Array<Maybe<InspectionType>>>;
};


export type PsiInspectionTypesArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type PsiFilter = {
  accountId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  orgCode: Scalars['String'];
};

export type PsiNote = {
  __typename?: 'PsiNote';
  agentId?: Maybe<Scalars['Int']>;
  agentName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  noteText?: Maybe<Scalars['String']>;
  noteType?: Maybe<Scalars['String']>;
  sparkUser?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type PullVehicleRequest = {
  orgCode?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['Int'];
  vin: Scalars['String'];
};

export type PushVehicleToAmsResults = {
  __typename?: 'PushVehicleToAmsResults';
  message?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PushVehiclesToAmsResults = {
  __typename?: 'PushVehiclesToAmsResults';
  results?: Maybe<Array<Maybe<SinglePushVehicleToAmsResult>>>;
};

export type Query = {
  __typename?: 'Query';
  accessoryDrawerState?: Maybe<AccessoryDrawerDisplay>;
  /** @deprecated Use zustand store */
  activeOrganization: Organization;
  adminUserAttributes: UserAttributes;
  administrator?: Maybe<Administrator>;
  auction?: Maybe<Auction>;
  auctionCollection?: Maybe<Auction>;
  dashboardReflowTrigger?: Maybe<Scalars['Float']>;
  dashboards: Array<Scalars['String']>;
  documentTypes: Array<DocType>;
  getAgentByAuctionAccess?: Maybe<QueryAgentResponse>;
  getVenueEvent?: Maybe<QueryResponse>;
  getVenueEventRunList?: Maybe<QueryRunListResponse>;
  getVenueEvents?: Maybe<QueryEventsListResponse>;
  isEditingLayouts: Scalars['Boolean'];
  layouts: Scalars['String'];
  passwordRecoveryEmail: Scalars['String'];
  pastSearches?: Maybe<Array<Maybe<PastSearch>>>;
  profile?: Maybe<Profile>;
  roles: Array<RoleAttributes>;
  tempLayouts: Scalars['String'];
  user?: Maybe<User>;
};


export type QueryAdminUserAttributesArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryAuctionArgs = {
  amsId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stockNumber?: InputMaybe<Scalars['String']>;
};


export type QueryAuctionCollectionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDashboardsArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAgentByAuctionAccessArgs = {
  auctionAccessId?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['String']>;
};


export type QueryGetVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};


export type QueryGetVenueEventRunListArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<RunListFilter>;
  pagination?: InputMaybe<PaginationControls>;
};


export type QueryGetVenueEventsArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<EventsListFilter>;
  pagination?: InputMaybe<PaginationControls>;
};

export type QueryAgentResponse = SparkResponse & {
  __typename?: 'QueryAgentResponse';
  data?: Maybe<AgentDealerResponse>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type QueryEventsListResponse = SparkResponse & {
  __typename?: 'QueryEventsListResponse';
  data?: Maybe<Array<Maybe<VenueEvent>>>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
};

export type QueryResponse = SparkResponse & {
  __typename?: 'QueryResponse';
  data?: Maybe<VenueEvent>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type QueryRunListResponse = SparkPaginatedResponse & {
  __typename?: 'QueryRunListResponse';
  data?: Maybe<Array<Maybe<VenueSaleListingAsset>>>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
};

export type RegisterBidderDetails = {
  bidderAA?: InputMaybe<Scalars['String']>;
  dealerAA?: InputMaybe<Scalars['String']>;
  orgCode?: InputMaybe<Scalars['String']>;
  saleListingKey?: InputMaybe<Scalars['String']>;
};

export type RegisterBidderResponse = {
  __typename?: 'RegisterBidderResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type Report = {
  __typename?: 'Report';
  auctionType?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Int']>;
  longDescription?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  reportId?: Maybe<Scalars['Int']>;
  reportLongName?: Maybe<Scalars['String']>;
  reportShortName?: Maybe<Scalars['String']>;
  reportUrl?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ReportColumn = {
  __typename?: 'ReportColumn';
  header?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ReportColumnInput = {
  header?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type ReportConfig = {
  __typename?: 'ReportConfig';
  PK?: Maybe<Scalars['String']>;
  SK?: Maybe<Scalars['String']>;
  auctionId?: Maybe<Scalars['String']>;
  cardViewConfig?: Maybe<ListView>;
  dataConfig?: Maybe<DataConfig>;
  defaultSource?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  listViewConfig?: Maybe<ListView>;
  pdfViewConfig?: Maybe<ListView>;
  reportKey?: Maybe<Scalars['String']>;
  scope?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchResults?: Maybe<ConfigSearchResults>;
  userId?: Maybe<Scalars['String']>;
};

export type ReportDateOffset = {
  __typename?: 'ReportDateOffset';
  end?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
};

export type ReportDetailPage = {
  __typename?: 'ReportDetailPage';
  displayName: Scalars['String'];
  name: Scalars['String'];
  requiredRoles?: Maybe<Array<Scalars['String']>>;
  url: Scalars['String'];
};

export type ReportFilter = {
  auctionType?: InputMaybe<Scalars['String']>;
};

export type ReportSearchFilter = {
  __typename?: 'ReportSearchFilter';
  dataQuery?: Maybe<Scalars['String']>;
  dateOffset?: Maybe<ReportDateOffset>;
  forFollowup?: Maybe<Scalars['String']>;
  searchString?: Maybe<Scalars['String']>;
  searchType?: Maybe<Search_Types>;
  statusCode?: Maybe<Scalars['String']>;
  watched?: Maybe<Scalars['Boolean']>;
};

export type ResendUnconfirmedPasswordInput = {
  admin?: InputMaybe<AdminInputSub>;
  auctionId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type ResetPasswordByEmailInput = {
  email: Scalars['String'];
};

export type ResetPasswordByEmailResponse = {
  __typename?: 'ResetPasswordByEmailResponse';
  statusCode: Scalars['Int'];
  statusMessage: Scalars['String'];
  userEmail: Scalars['String'];
};

export type ReverseSaleRequest = {
  orgCode?: InputMaybe<Scalars['String']>;
  saleDate?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['Int'];
  vin: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type RoleAttributes = {
  __typename?: 'RoleAttributes';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type RunListFilter = {
  text?: InputMaybe<Scalars['String']>;
};

export enum Search_Sort_Types {
  AgentPurchasesByDate = 'AGENT_PURCHASES_BY_DATE',
  BuyerAccount = 'BUYER_ACCOUNT',
  BuyerAgent = 'BUYER_AGENT',
  CheckIn = 'CHECK_IN',
  DaysOnLot = 'DAYS_ON_LOT',
  IfOfferCreatedDate = 'IF_OFFER_CREATED_DATE',
  MakeModelYear = 'MAKE_MODEL_YEAR',
  Odometer = 'ODOMETER',
  RanAt = 'RAN_AT',
  RunNumber = 'RUN_NUMBER',
  SaleDateLaneLot = 'SALE_DATE_LANE_LOT',
  SaleDateLastRanTime = 'SALE_DATE_LAST_RAN_TIME',
  SellerAccount = 'SELLER_ACCOUNT',
  SellerMakeModelYear = 'SELLER_MAKE_MODEL_YEAR',
  SoldDateLastRanTime = 'SOLD_DATE_LAST_RAN_TIME',
  StockLotDays = 'STOCK_LOT_DAYS',
  Year = 'YEAR',
  YearMakeModel = 'YEAR_MAKE_MODEL'
}

export enum Search_Types {
  Bidders = 'BIDDERS',
  Broad = 'BROAD',
  Company = 'COMPANY',
  ContactLogs = 'CONTACT_LOGS',
  OnlineListing = 'ONLINE_LISTING',
  Vehicles = 'VEHICLES',
  VehiclesByBuyers = 'VEHICLES_BY_BUYERS',
  VehiclesByCompany = 'VEHICLES_BY_COMPANY',
  VehiclesStats = 'VEHICLES_STATS'
}

export enum Sort_Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SaleEvent = {
  __typename?: 'SaleEvent';
  buyerAgentAaNum?: Maybe<Scalars['String']>;
  buyerAgentStatusCode?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerOrgAaNum?: Maybe<Scalars['String']>;
  buyerOrgStatusCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  dealSaleAmt?: Maybe<Scalars['Int']>;
  dealStatus?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['String']>;
  eventEndTs?: Maybe<Scalars['String']>;
  eventEndedAtTs?: Maybe<Scalars['String']>;
  eventStartTs?: Maybe<Scalars['String']>;
  eventTitle?: Maybe<Scalars['String']>;
  floorPrice?: Maybe<Scalars['Int']>;
  lane?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  saleListingKey?: Maybe<Scalars['String']>;
  saleListingStatus?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  venueEventKey?: Maybe<Scalars['String']>;
  venueEventTypeCode?: Maybe<Scalars['String']>;
};

export type SaleListing = {
  __typename?: 'SaleListing';
  buyerAgentEmail?: Maybe<Scalars['String']>;
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerAgentName?: Maybe<Scalars['String']>;
  buyerAgentNotes?: Maybe<Scalars['String']>;
  buyerAgentPhoneMobile?: Maybe<Scalars['String']>;
  buyerAgentPicture?: Maybe<Scalars['String']>;
  hasRun?: Maybe<Scalars['Boolean']>;
  lane?: Maybe<Scalars['String']>;
  listingCondition?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  saleDate?: Maybe<Scalars['String']>;
  saleListingDealSoldAt?: Maybe<Scalars['String']>;
  saleListingOfferCreatedAt?: Maybe<Scalars['String']>;
  saleMethod?: Maybe<Scalars['String']>;
  saleStatus?: Maybe<Scalars['String']>;
  sellerAgentEmail?: Maybe<Scalars['String']>;
  sellerAgentId?: Maybe<Scalars['Int']>;
  sellerAgentName?: Maybe<Scalars['String']>;
  sellerAgentPhoneMobile?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  soldDateLastRanTime?: Maybe<Scalars['String']>;
  venueCode?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  venueUrl?: Maybe<Scalars['String']>;
};

export type SalesDayStatistics = {
  __typename?: 'SalesDayStatistics';
  checkedIn?: Maybe<Scalars['Int']>;
  checkedInToday?: Maybe<Scalars['Int']>;
  missingCRs?: Maybe<Scalars['Int']>;
  needsPhotos?: Maybe<Scalars['Int']>;
  run?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
};

export type SearchAccount = {
  __typename?: 'SearchAccount';
  accountId?: Maybe<Scalars['String']>;
  accountKey?: Maybe<Scalars['String']>;
  accountLegacyType?: Maybe<Scalars['String']>;
  accountSalesRep?: Maybe<Scalars['String']>;
  auctionAccess?: Maybe<Scalars['String']>;
  canBuy?: Maybe<Scalars['Boolean']>;
  canSell?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  dbaName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  establishedAt?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  lastAttendedAt?: Maybe<Scalars['String']>;
  lastBoughtAt?: Maybe<Scalars['String']>;
  lastSoldAt?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type SearchAgent = {
  __typename?: 'SearchAgent';
  accountKey?: Maybe<Scalars['String']>;
  accountSalesRep?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  auctionAccess?: Maybe<Scalars['String']>;
  cellPhone?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  dbaName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastAttendBadgeIssuedAt?: Maybe<Scalars['String']>;
  lastAttendBadgeNum?: Maybe<Scalars['String']>;
  lastAttendBidderType?: Maybe<Scalars['String']>;
  lastAttendDate?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
};

export type SearchBidder = {
  __typename?: 'SearchBidder';
  BadgeIssuedAt?: Maybe<Scalars['String']>;
  BadgeNum?: Maybe<Scalars['String']>;
  BidderType?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  auctionAccess?: Maybe<Scalars['String']>;
  cellPhone?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  consignor?: Maybe<Scalars['String']>;
  consignorId?: Maybe<Scalars['String']>;
  consignorLegacyId?: Maybe<Scalars['String']>;
  consignorLegacyType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  vehiclesPurchasedCount?: Maybe<Scalars['Int']>;
  workPhone?: Maybe<Scalars['String']>;
};

export type SearchConfigInput = {
  pageInfo?: InputMaybe<PageInfoConfigInput>;
  searchString?: InputMaybe<Scalars['String']>;
  searchType?: InputMaybe<Search_Types>;
  subtitle?: InputMaybe<Scalars['String']>;
};

export type SearchContactLog = {
  __typename?: 'SearchContactLog';
  accountAuctionAccess?: Maybe<Scalars['String']>;
  accountDisplayName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  accountKey?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  agentName?: Maybe<Scalars['String']>;
  auctionCode?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  completedBy?: Maybe<Scalars['String']>;
  completedEmail?: Maybe<Scalars['String']>;
  completedFullName?: Maybe<Scalars['String']>;
  completedUserid?: Maybe<Scalars['String']>;
  completedUsername?: Maybe<Scalars['String']>;
  contactedAt?: Maybe<Scalars['String']>;
  creatorEmail?: Maybe<Scalars['String']>;
  creatorFullName?: Maybe<Scalars['String']>;
  creatorUserid?: Maybe<Scalars['String']>;
  creatorUsername?: Maybe<Scalars['String']>;
  followUpDate?: Maybe<Scalars['String']>;
  followUpUserId?: Maybe<Scalars['String']>;
  followupAt?: Maybe<Scalars['String']>;
  followupEmail?: Maybe<Scalars['String']>;
  followupFullName?: Maybe<Scalars['String']>;
  followupUserid?: Maybe<Scalars['String']>;
  followupUsername?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
  update?: Maybe<Scalars['String']>;
};

export type SearchFilter = {
  createCSV?: InputMaybe<Scalars['Boolean']>;
  searchString: Scalars['String'];
  type?: InputMaybe<Search_Types>;
  useSQL?: InputMaybe<Scalars['Boolean']>;
};

export type SearchPageInfo = {
  aggrSortOrder?: InputMaybe<Sort_Direction>;
  aggrSortType?: InputMaybe<Aggr_Search_Sort_Types>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortColumns?: InputMaybe<Array<InputMaybe<SortColumnInput>>>;
  sortOrder?: InputMaybe<Sort_Direction>;
  sortType?: InputMaybe<Search_Sort_Types>;
  top?: InputMaybe<Scalars['Int']>;
};

export type SearchResults = {
  __typename?: 'SearchResults';
  accountCount?: Maybe<Scalars['Int']>;
  accountResult?: Maybe<Array<Maybe<SearchAccount>>>;
  agentCount?: Maybe<Scalars['Int']>;
  agentResult?: Maybe<Array<Maybe<SearchAgent>>>;
  bidderCount?: Maybe<Scalars['Int']>;
  bidderResult?: Maybe<Array<Maybe<SearchBidder>>>;
  contactLogCount?: Maybe<Scalars['Int']>;
  contactLogResult?: Maybe<Array<Maybe<SearchContactLog>>>;
  contactLogStats?: Maybe<ContactLogStats>;
  searchStringDisplay?: Maybe<Scalars['String']>;
  searchStringJson?: Maybe<Scalars['String']>;
  searchType?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  vehicleCount?: Maybe<Scalars['Int']>;
  vehicleInSaleCount?: Maybe<Scalars['Int']>;
  vehicleInSaleResult?: Maybe<Array<Maybe<SearchVehicle>>>;
  vehicleRecentlySoldCount?: Maybe<Scalars['Int']>;
  vehicleRecentlySoldResult?: Maybe<Array<Maybe<SearchVehicle>>>;
  vehicleResult?: Maybe<Array<Maybe<SearchVehicle>>>;
  vehicleResultCsvUrl?: Maybe<Scalars['String']>;
  vehicleStats?: Maybe<VehicleStats>;
  vehicleStatsByCompany?: Maybe<Array<Maybe<VehicleStatsByCompany>>>;
};

export type SearchSort = {
  favorites?: InputMaybe<Scalars['Boolean']>;
};

export type SearchVehicle = {
  __typename?: 'SearchVehicle';
  accountSalesRep?: Maybe<Scalars['String']>;
  allCurrentSales?: Maybe<Array<Maybe<CurrentSale>>>;
  announcementFour?: Maybe<Scalars['String']>;
  announcementLight?: Maybe<Scalars['String']>;
  announcementOne?: Maybe<Scalars['String']>;
  announcementThree?: Maybe<Scalars['String']>;
  announcementTwo?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  ballControlCode?: Maybe<Scalars['String']>;
  buyer?: Maybe<Scalars['String']>;
  buyerAccountKey?: Maybe<Scalars['String']>;
  buyerAgentAaNum?: Maybe<Scalars['String']>;
  buyerAgentBadge?: Maybe<Scalars['String']>;
  buyerAgentEmail?: Maybe<Scalars['String']>;
  buyerAgentId?: Maybe<Scalars['String']>;
  buyerAgentName?: Maybe<Scalars['String']>;
  buyerAgentPhoneMobile?: Maybe<Scalars['String']>;
  buyerAgentStatusCode?: Maybe<Scalars['String']>;
  buyerAuctionAccess?: Maybe<Scalars['String']>;
  buyerAuctionRep?: Maybe<Scalars['String']>;
  buyerCity?: Maybe<Scalars['String']>;
  buyerDisplayName?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['String']>;
  buyerLegacyId?: Maybe<Scalars['String']>;
  buyerLegacyType?: Maybe<Scalars['String']>;
  buyerOrgAaNum?: Maybe<Scalars['String']>;
  buyerOrgStatusCode?: Maybe<Scalars['String']>;
  buyerState?: Maybe<Scalars['String']>;
  checkedInAt?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  consignor?: Maybe<Scalars['String']>;
  consignorAuctionAccess?: Maybe<Scalars['String']>;
  consignorId?: Maybe<Scalars['String']>;
  consignorLegacyId?: Maybe<Scalars['String']>;
  consignorLegacyType?: Maybe<Scalars['String']>;
  consignorStockNumber?: Maybe<Scalars['String']>;
  daysOnLot?: Maybe<Scalars['String']>;
  dealCurrentOfferAmount?: Maybe<Scalars['String']>;
  dealNote?: Maybe<Scalars['String']>;
  floorAmount?: Maybe<Scalars['String']>;
  hasCr?: Maybe<Scalars['String']>;
  hasTitle?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['String']>;
  lane?: Maybe<Scalars['String']>;
  latestNegotiationBuyerSellerAccountId?: Maybe<Scalars['String']>;
  latestNegotiationDealBuyerAccountDisplayName?: Maybe<Scalars['String']>;
  latestNegotiationDealBuyerAgentName?: Maybe<Scalars['String']>;
  latestNegotiationDealSoldAt?: Maybe<Scalars['String']>;
  latestNegotiationEventDealCurrentOfferAmount?: Maybe<Scalars['String']>;
  latestNegotiationIsOpen?: Maybe<Scalars['String']>;
  latestNegotiationLastEventCreatedAt?: Maybe<Scalars['String']>;
  latestNegotiationStatus?: Maybe<Scalars['String']>;
  latestNegotiationStatusCode?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['String']>;
  orgCode?: Maybe<Scalars['String']>;
  photoCount?: Maybe<Scalars['String']>;
  pipelineUri?: Maybe<Scalars['String']>;
  proxyWon?: Maybe<Scalars['String']>;
  psiAmsPrinterName?: Maybe<Scalars['String']>;
  psiAmsServiceResultCode?: Maybe<Scalars['String']>;
  psiChargeAmount?: Maybe<Scalars['Int']>;
  psiCreatedAt?: Maybe<Scalars['String']>;
  psiLongDesc?: Maybe<Scalars['String']>;
  psiNotes?: Maybe<Scalars['String']>;
  psiOrderedAt?: Maybe<Scalars['String']>;
  psiOrderedByAmsUser?: Maybe<Scalars['String']>;
  psiOrderedBySparkAuthenticationUsername?: Maybe<Scalars['String']>;
  psiOrderedBySparkUserId?: Maybe<Scalars['Int']>;
  psiRackPrice?: Maybe<Scalars['String']>;
  psiRequested?: Maybe<Scalars['String']>;
  psiResultBySparkAuthenticationUsername?: Maybe<Scalars['String']>;
  psiServiceCode?: Maybe<Scalars['String']>;
  psiShortDesc?: Maybe<Scalars['String']>;
  psiStatusCode?: Maybe<Scalars['String']>;
  ranAt?: Maybe<Scalars['String']>;
  ranCount?: Maybe<Scalars['String']>;
  run?: Maybe<Scalars['String']>;
  runPadded?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['String']>;
  saleDate?: Maybe<Scalars['String']>;
  saleDateLastRanTime?: Maybe<Scalars['String']>;
  saleListingKey?: Maybe<Scalars['String']>;
  saleMethod?: Maybe<Scalars['String']>;
  saleType?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['String']>;
  sellerAccountKey?: Maybe<Scalars['String']>;
  sellerAgentEmail?: Maybe<Scalars['String']>;
  sellerAgentId?: Maybe<Scalars['String']>;
  sellerAgentName?: Maybe<Scalars['String']>;
  sellerAgentPhoneMobile?: Maybe<Scalars['String']>;
  sellerAuctionRep?: Maybe<Scalars['String']>;
  sellerDisplayName?: Maybe<Scalars['String']>;
  soldDateLastRanTime?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  sourceSystemKey?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  thumbUrl?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
  venueCode?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  venueUrl?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'Service';
  AssetServiceStatusId?: Maybe<Scalars['String']>;
  amsChargeCode?: Maybe<Scalars['String']>;
  amsPrinterName?: Maybe<Scalars['String']>;
  amsServiceProductCode?: Maybe<Scalars['String']>;
  amsServiceResultCode?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  chargeAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  dealId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organizationServiceProductId?: Maybe<Scalars['String']>;
  serviceClassCode?: Maybe<Scalars['String']>;
  serviceOrderedAt?: Maybe<Scalars['String']>;
  serviceOrderedByAmsUser?: Maybe<Scalars['String']>;
  serviceOrderedByPipelineUser?: Maybe<Scalars['String']>;
  serviceOrderedBySparkUserId?: Maybe<Scalars['String']>;
  serviceProductDescription?: Maybe<Scalars['String']>;
  serviceResultAt?: Maybe<Scalars['String']>;
  serviceResultByAmsUser?: Maybe<Scalars['String']>;
  serviceResultBySparkUser?: Maybe<Scalars['String']>;
  serviceResultedInArbitration?: Maybe<Scalars['String']>;
};

export type ServiceResponse = {
  __typename?: 'ServiceResponse';
  serviceClass?: Maybe<Scalars['String']>;
  serviceCode?: Maybe<Scalars['String']>;
  serviceCodeDescription?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
  statusText?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type SetAnnouncements = {
  announcement: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  ordinal: Scalars['Int'];
};

export type SetFloorPrice = {
  newValue?: InputMaybe<Scalars['Int']>;
  oldValue?: InputMaybe<Scalars['Int']>;
};

export type SetLights = {
  newValue?: InputMaybe<Scalars['String']>;
  oldValue?: InputMaybe<Scalars['String']>;
};

export type SetVehicleInfoResults = {
  __typename?: 'SetVehicleInfoResults';
  cancelProxyBidsResult?: Maybe<CancelProxyBidsResult>;
  results?: Maybe<Array<Maybe<AmsCallResult>>>;
};

export type ShareReportResponse = SparkResponse & {
  __typename?: 'ShareReportResponse';
  data?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type SinglePushVehicleToAmsResult = {
  __typename?: 'SinglePushVehicleToAmsResult';
  id: Scalars['ID'];
  isPossible: Scalars['Boolean'];
};

export type Site = {
  __typename?: 'Site';
  auctionName?: Maybe<Scalars['String']>;
  biCode?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  lookoutCodeName?: Maybe<Scalars['String']>;
  pipelineCode?: Maybe<Scalars['String']>;
};

export type SortColumn = {
  __typename?: 'SortColumn';
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Sort_Direction>;
};

export type SortColumnInput = {
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort_Direction>;
};

export type SparkPaginatedResponse = {
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
};

export type SparkResponse = {
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type StartBidTier = {
  __typename?: 'StartBidTier';
  amountBelowPriceFloor?: Maybe<Scalars['Int']>;
  priceFloorLBound?: Maybe<Scalars['Int']>;
  priceFloorUBound?: Maybe<Scalars['Int']>;
};

export type StartBidTierInput = {
  amountBelowPriceFloor?: InputMaybe<Scalars['Int']>;
  priceFloorLBound?: InputMaybe<Scalars['Int']>;
  priceFloorUBound?: InputMaybe<Scalars['Int']>;
};

export type StatisticsFilter = {
  dataSource?: InputMaybe<Scalars['String']>;
  dates?: InputMaybe<DateRange>;
  photoCount?: InputMaybe<NumberRange>;
};

export type TestVehicleAuditLog = {
  __typename?: 'TestVehicleAuditLog';
  account?: Maybe<Scalars['String']>;
  auction_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  detail_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type TrendInfo = {
  __typename?: 'TrendInfo';
  avgPerWeekLast90?: Maybe<Scalars['Int']>;
  last7?: Maybe<Scalars['Int']>;
  last90?: Maybe<Scalars['Int']>;
};

export type Trends = {
  __typename?: 'Trends';
  consigned?: Maybe<TrendInfo>;
  purchased?: Maybe<TrendInfo>;
  sold?: Maybe<TrendInfo>;
};

export type TrendsFilter = {
  buyerOrSellerAccountId?: InputMaybe<Scalars['Int']>;
};

export enum User_Types {
  External = 'EXTERNAL',
  Spark = 'SPARK'
}

export type UpateAllListingsMutationResponse = SparkResponse & {
  __typename?: 'UpateAllListingsMutationResponse';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type UpdateAgentContact = {
  agentId?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Scalars['Int']>;
  contactedAt?: InputMaybe<Scalars['String']>;
  followUpDate?: InputMaybe<Scalars['String']>;
  followUpUserId?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  statusCode?: InputMaybe<Scalars['String']>;
  typeCode?: InputMaybe<Scalars['String']>;
};

export type UpdateAllVenueAssets = {
  amount: Scalars['Int'];
  dataField: AdjustPricingDataFieldEnum;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  type: AdjustPricingMethodEnum;
};

export type UpdateDocumentInput = {
  deleted?: InputMaybe<Scalars['Int']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  docId: Scalars['String'];
  docName?: InputMaybe<Scalars['String']>;
  docTypeId?: InputMaybe<Scalars['String']>;
  docTypeName?: InputMaybe<Scalars['String']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type UpdateDocumentsResponse = {
  __typename?: 'UpdateDocumentsResponse';
  totalDocsUpdated?: Maybe<Scalars['Int']>;
  totalVehiclesUpdated?: Maybe<Scalars['Int']>;
};

export type UpdateFavoritesInput = {
  accountGroupId?: InputMaybe<Scalars['Int']>;
  accountKey: Scalars['String'];
  isFavorite: Scalars['Boolean'];
  orgCode: Scalars['String'];
};

export type UpdateRoles = {
  authenticationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roleId: Scalars['Int'];
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserInput = {
  admin?: InputMaybe<AdminInput>;
  updatedAttributes?: InputMaybe<UserAttributesInput>;
  updatedCard?: InputMaybe<DashboardCardInput>;
  updatedDashboard?: InputMaybe<DashboardInput>;
  updatedDashboards?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedOrganizations?: InputMaybe<Array<OrganizationInput>>;
  updatedRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type User = {
  __typename?: 'User';
  attributes?: Maybe<UserAttributes>;
  biRoles?: Maybe<Scalars['String']>;
  dashboardList?: Maybe<Dashboards>;
  dashboards?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  permissions?: Maybe<UserPermissions>;
  roles?: Maybe<Array<Maybe<RoleAttributes>>>;
};


export type UserDashboardListArgs = {
  filter?: InputMaybe<DashboardFilter>;
};

export type UserAttributes = {
  __typename?: 'UserAttributes';
  auctionAccessNumber?: Maybe<Scalars['String']>;
  authenticationId?: Maybe<Scalars['String']>;
  authenticationSource?: Maybe<Scalars['String']>;
  authenticationUsername?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  customRoles?: Maybe<Scalars['String']>;
  databaseId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isGlobalAdmin?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['String']>;
  lockedBy?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
};

export type UserAttributesInput = {
  auctionAccessNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isGlobalAdmin?: InputMaybe<Scalars['Boolean']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  workPhone?: InputMaybe<Scalars['String']>;
};

export type UserMutationResponse = {
  __typename?: 'UserMutationResponse';
  auctionAccessNumber?: Maybe<Scalars['String']>;
  authenticationId?: Maybe<Scalars['String']>;
  authenticationUsername?: Maybe<Scalars['String']>;
  databaseId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isGlobalAdmin?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
  statusMessage?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  orgPermissions?: Maybe<Array<Maybe<PermissionItem>>>;
  userPermissions?: Maybe<Array<Maybe<PermissionItem>>>;
};


export type UserPermissionsOrgPermissionsArgs = {
  auctionId: Scalars['String'];
};

export type VdpByStockNumberResults = {
  __typename?: 'VdpByStockNumberResults';
  assetId?: Maybe<Scalars['ID']>;
  uaId?: Maybe<Scalars['String']>;
};

export type VehicleAmsResponse = {
  __typename?: 'VehicleAMSResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type VehicleDataTypes = OnlineListing | SearchVehicle | VehicleStatsByCompany;

export type VehicleStats = {
  __typename?: 'VehicleStats';
  avgSaleAmount?: Maybe<Scalars['Int']>;
  completed?: Maybe<Scalars['Int']>;
  conversion?: Maybe<Scalars['Float']>;
  ran?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  sumSaleAmount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type VehicleStatsByCompany = {
  __typename?: 'VehicleStatsByCompany';
  accountId?: Maybe<Scalars['Int']>;
  accountName?: Maybe<Scalars['String']>;
  avgSaleAmount?: Maybe<Scalars['Int']>;
  conversion?: Maybe<Scalars['Float']>;
  ran?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  sumSaleAmount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type VehiclesWithDocsResponse = {
  __typename?: 'VehiclesWithDocsResponse';
  totalDocCount?: Maybe<Scalars['Int']>;
  vehiclesWithDocsCount?: Maybe<Scalars['Int']>;
};

export type VenueEvent = {
  __typename?: 'VenueEvent';
  endedAt?: Maybe<Scalars['String']>;
  eventDate: Scalars['String'];
  eventEndTime?: Maybe<Scalars['String']>;
  eventSettings?: Maybe<AuctionSettings>;
  eventStartTime: Scalars['String'];
  eventTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventTitle: Scalars['String'];
  eventType: Scalars['String'];
  eventTypeDisplayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  noSale?: Maybe<Scalars['Int']>;
  onOffer?: Maybe<Scalars['Int']>;
  orgCode?: Maybe<Scalars['String']>;
  originatingOrgCode?: Maybe<Scalars['String']>;
  participatingAuctions: Array<Maybe<Scalars['String']>>;
  sales?: Maybe<Scalars['Int']>;
  shortDescription?: Maybe<Scalars['String']>;
  sold?: Maybe<Scalars['Int']>;
  unitCount?: Maybe<Scalars['Int']>;
  venueCode?: Maybe<Scalars['String']>;
};

export type VenueSaleListingAsset = {
  __typename?: 'VenueSaleListingAsset';
  announcementLight?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  assetOrigin?: Maybe<Scalars['String']>;
  bidIncrement?: Maybe<Scalars['Int']>;
  blackBook?: Maybe<Scalars['Int']>;
  buyNowPrice?: Maybe<Scalars['Int']>;
  consignor?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  floorPrice?: Maybe<Scalars['Int']>;
  grade?: Maybe<Scalars['Float']>;
  hasCr?: Maybe<Scalars['Boolean']>;
  lane?: Maybe<Scalars['String']>;
  listingCondition?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  mmr?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  orgCode?: Maybe<Scalars['String']>;
  ranCount?: Maybe<Scalars['Int']>;
  saleListingId?: Maybe<Scalars['String']>;
  startBid?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type VenueSaleListingAssetInput = {
  allCurrentSales?: InputMaybe<Array<InputMaybe<CurrentSaleInput>>>;
  announcementLight?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['ID']>;
  bidIncrement?: InputMaybe<Scalars['Int']>;
  blackBook?: InputMaybe<Scalars['Int']>;
  buyNowPrice?: InputMaybe<Scalars['Int']>;
  consignor?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  floorPrice?: InputMaybe<Scalars['Int']>;
  grade?: InputMaybe<Scalars['Float']>;
  hasCr?: InputMaybe<Scalars['Boolean']>;
  lane?: InputMaybe<Scalars['String']>;
  listingCondition?: InputMaybe<Scalars['String']>;
  lot?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mmr?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  orgCode?: InputMaybe<Scalars['String']>;
  removalReason?: InputMaybe<Scalars['String']>;
  saleListingId?: InputMaybe<Scalars['String']>;
  startBid?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export enum ViewType {
  CardView = 'card_view',
  ListView = 'list_view',
  PdfView = 'pdf_view'
}

export type Watcher = {
  __typename?: 'Watcher';
  emailAddress?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PushToAmsResponse = {
  __typename?: 'pushToAMSResponse';
  results?: Maybe<Array<Maybe<PushToAmsResposeResult>>>;
};

export type PushToAmsResposeResult = {
  __typename?: 'pushToAMSResposeResult';
  id: Scalars['ID'];
  success: PendingSuccess;
};

export type SendMessageStatus = {
  __typename?: 'sendMessageStatus';
  emailSentStatus?: Maybe<Scalars['String']>;
  smsSentStatus?: Maybe<Scalars['String']>;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AGGR_SEARCH_SORT_TYPES: Aggr_Search_Sort_Types;
  AMSUpdateResponseMessages: ResolverTypeWrapper<AmsUpdateResponseMessages>;
  AccessoryDrawerDisplay: AccessoryDrawerDisplay;
  Account: ResolverTypeWrapper<Account>;
  AccountGroupAccounts: ResolverTypeWrapper<AccountGroupAccounts>;
  AccountGroupUsers: ResolverTypeWrapper<AccountGroupUsers>;
  AccountGroups: ResolverTypeWrapper<AccountGroups>;
  AccountGroupsFilter: AccountGroupsFilter;
  AccountNote: ResolverTypeWrapper<AccountNote>;
  AccountSortBy: AccountSortBy;
  AccountSortingKey: AccountSortingKey;
  Accounts: ResolverTypeWrapper<Accounts>;
  AccountsFilter: AccountsFilter;
  AdjustPricingDataFieldEnum: AdjustPricingDataFieldEnum;
  AdjustPricingMethodEnum: AdjustPricingMethodEnum;
  AdminInput: AdminInput;
  AdminInputSub: AdminInputSub;
  Administrator: ResolverTypeWrapper<Administrator>;
  Agent: ResolverTypeWrapper<Agent>;
  AgentCompany: ResolverTypeWrapper<AgentCompany>;
  AgentDealerResponse: ResolverTypeWrapper<AgentDealerResponse>;
  AgentNote: ResolverTypeWrapper<AgentNote>;
  AgentNoteType: ResolverTypeWrapper<AgentNoteType>;
  AgentNoteUpdate: AgentNoteUpdate;
  AgentNoteUpdateResult: ResolverTypeWrapper<AgentNoteUpdateResult>;
  AgentRole: ResolverTypeWrapper<AgentRole>;
  AgentRoleAction: AgentRoleAction;
  AgentRoleUpdate: AgentRoleUpdate;
  AgentRoleUpdateResult: ResolverTypeWrapper<AgentRoleUpdateResult>;
  AgentRoleUpdateResults: ResolverTypeWrapper<AgentRoleUpdateResults>;
  Agents: ResolverTypeWrapper<Agents>;
  AgentsFilter: AgentsFilter;
  AmsCallResult: ResolverTypeWrapper<AmsCallResult>;
  AmsResponse: ResolverTypeWrapper<AmsResponse>;
  Announcement: ResolverTypeWrapper<Announcement>;
  Asset: ResolverTypeWrapper<Asset>;
  AssetFees: ResolverTypeWrapper<AssetFees>;
  AssetFilter: AssetFilter;
  Assets: ResolverTypeWrapper<Assets>;
  Attendance: ResolverTypeWrapper<Attendance>;
  AttendanceList: ResolverTypeWrapper<AttendanceList>;
  Auction: ResolverTypeWrapper<Auction>;
  AuctionAmsInfo: ResolverTypeWrapper<AuctionAmsInfo>;
  AuctionCollection: ResolverTypeWrapper<AuctionCollection>;
  AuctionKey: ResolverTypeWrapper<AuctionKey>;
  AuctionSettings: ResolverTypeWrapper<AuctionSettings>;
  AuctionSettingsInput: AuctionSettingsInput;
  AuctionSettingsResponse: ResolverTypeWrapper<AuctionSettingsResponse>;
  AuctionStatistics: ResolverTypeWrapper<AuctionStatistics>;
  Audit: ResolverTypeWrapper<Audit>;
  AuditInput: AuditInput;
  AuditResponse: ResolverTypeWrapper<AuditResponse>;
  BallControlCode: BallControlCode;
  Bidder: ResolverTypeWrapper<Bidder>;
  BidderList: ResolverTypeWrapper<BidderList>;
  BiddersFilter: BiddersFilter;
  BiddingStatistics: ResolverTypeWrapper<BiddingStatistics>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BuyNowTier: ResolverTypeWrapper<BuyNowTier>;
  BuyNowTierInput: BuyNowTierInput;
  CacheShape: ResolverTypeWrapper<CacheShape>;
  CalculatedIfOfferData: ResolverTypeWrapper<CalculatedIfOfferData>;
  CancelProxyBidsResult: ResolverTypeWrapper<CancelProxyBidsResult>;
  Card: ResolverTypeWrapper<Card>;
  CardFilter: CardFilter;
  ColOptions: ColOptions;
  CompaniesList: ResolverTypeWrapper<CompaniesList>;
  ConditionReport: ResolverTypeWrapper<ConditionReport>;
  ConfigSearchResults: ResolverTypeWrapper<Omit<ConfigSearchResults, 'vehicleData'> & { vehicleData?: Maybe<Array<Maybe<ResolversTypes['VehicleDataTypes']>>> }>;
  Contact: ResolverTypeWrapper<Contact>;
  ContactFilter: ContactFilter;
  ContactList: ResolverTypeWrapper<ContactList>;
  ContactLogStats: ResolverTypeWrapper<ContactLogStats>;
  ContactManagement: ResolverTypeWrapper<ContactManagement>;
  ContactSortBy: ContactSortBy;
  ContactSortKey: ContactSortKey;
  ContactStatus: ResolverTypeWrapper<ContactStatus>;
  ContactType: ResolverTypeWrapper<ContactType>;
  CreateAgentContact: CreateAgentContact;
  CreateDocumentInput: CreateDocumentInput;
  CreateDocumentOutputAsset: ResolverTypeWrapper<CreateDocumentOutputAsset>;
  CreateDocumentUploadDoc: ResolverTypeWrapper<CreateDocumentUploadDoc>;
  CreateDocumentsInputAsset: CreateDocumentsInputAsset;
  CreateDocumentsUploadItem: ResolverTypeWrapper<CreateDocumentsUploadItem>;
  CreateReportConfigInput: CreateReportConfigInput;
  CreateReportConfigResponse: ResolverTypeWrapper<CreateReportConfigResponse>;
  CreateUserInput: CreateUserInput;
  CreateVenueEvent: CreateVenueEvent;
  CreatedEventResponse: ResolverTypeWrapper<CreatedEventResponse>;
  CurrentSale: ResolverTypeWrapper<CurrentSale>;
  CurrentSaleInput: CurrentSaleInput;
  Dashboard: ResolverTypeWrapper<Dashboard>;
  DashboardCardInput: DashboardCardInput;
  DashboardFilter: DashboardFilter;
  DashboardInput: DashboardInput;
  Dashboards: ResolverTypeWrapper<Dashboards>;
  DataConfig: ResolverTypeWrapper<DataConfig>;
  DataSourceTypes: DataSourceTypes;
  DateRange: DateRange;
  Deal: ResolverTypeWrapper<Deal>;
  DealFilter: DealFilter;
  Dealer: ResolverTypeWrapper<Dealer>;
  DeleteAgentContact: DeleteAgentContact;
  DeleteUserInput: DeleteUserInput;
  DocType: ResolverTypeWrapper<DocType>;
  Document: ResolverTypeWrapper<Document>;
  DocumentActivity: ResolverTypeWrapper<DocumentActivity>;
  DocumentUploadURL: ResolverTypeWrapper<DocumentUploadUrl>;
  DocumentUploadURLsFilter: DocumentUploadUrLsFilter;
  DocumentView: ResolverTypeWrapper<DocumentView>;
  DocumentsFilter: DocumentsFilter;
  EventStatusesEnum: EventStatusesEnum;
  EventTriggerCode: EventTriggerCode;
  EventTypeCode: EventTypeCode;
  EventTypeTrigger: ResolverTypeWrapper<EventTypeTrigger>;
  EventTypesEnum: EventTypesEnum;
  EventsListFilter: EventsListFilter;
  ExitVehicleRequest: ExitVehicleRequest;
  ExpectedAnnouncement: ExpectedAnnouncement;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  FullSearch: FullSearch;
  GenerateFormats: GenerateFormats;
  GenerateOptions: GenerateOptions;
  GeneratePDFInput: GeneratePdfInput;
  GenericCard: ResolverTypeWrapper<GenericCard>;
  GetSingleUserInput: GetSingleUserInput;
  GetUserListInput: GetUserListInput;
  HttpResponse: ResolverTypeWrapper<HttpResponse>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IfOfferDetails: IfOfferDetails;
  IfOfferFilter: IfOfferFilter;
  IfOfferHistory: ResolverTypeWrapper<IfOfferHistory>;
  IfOfferManagement: ResolverTypeWrapper<IfOfferManagement>;
  IfOfferNoteType: IfOfferNoteType;
  IfOfferNotes: ResolverTypeWrapper<IfOfferNotes>;
  IfOfferUpdateAMSResponse: ResolverTypeWrapper<IfOfferUpdateAmsResponse>;
  IfOfferUpdateResult: ResolverTypeWrapper<IfOfferUpdateResult>;
  IfOfferUpdateResults: ResolverTypeWrapper<IfOfferUpdateResults>;
  InspectionInput: InspectionInput;
  InspectionType: ResolverTypeWrapper<InspectionType>;
  InspectionTypeFilter: ResolverTypeWrapper<InspectionTypeFilter>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Lane: ResolverTypeWrapper<Lane>;
  LaneList: ResolverTypeWrapper<LaneList>;
  LightOption: ResolverTypeWrapper<LightOption>;
  ListView: ResolverTypeWrapper<ListView>;
  ListViewConfigInput: ListViewConfigInput;
  LocalCreateDocumentInput: LocalCreateDocumentInput;
  LocalCreateDocumentOutput: ResolverTypeWrapper<LocalCreateDocumentOutput>;
  LocalUploadDocumentInput: LocalUploadDocumentInput;
  Location: ResolverTypeWrapper<Location>;
  LoginCredentials: LoginCredentials;
  LoginResponse: ResolverTypeWrapper<LoginResponse>;
  LoginResponseTypes: LoginResponseTypes;
  MaintenanceDetails: MaintenanceDetails;
  MaintenanceUpdateResult: ResolverTypeWrapper<MaintenanceUpdateResult>;
  Marketplace: ResolverTypeWrapper<Marketplace>;
  MarketplaceStatistics: ResolverTypeWrapper<MarketplaceStatistics>;
  MessageInput: MessageInput;
  MutateAccountGroupFilter: MutateAccountGroupFilter;
  Mutation: ResolverTypeWrapper<{}>;
  MutationDataResponse: ResolversTypes['VenueEvent'] | ResolversTypes['VenueSaleListingAsset'];
  MutationResponse: ResolverTypeWrapper<Omit<MutationResponse, 'data'> & { data?: Maybe<ResolversTypes['MutationDataResponse']> }>;
  NoSaleHistory: ResolverTypeWrapper<NoSaleHistory>;
  NoSaleRequest: NoSaleRequest;
  NumberRange: NumberRange;
  OnlineListing: ResolverTypeWrapper<OnlineListing>;
  OnlineListingFilter: OnlineListingFilter;
  OnlineListings: ResolverTypeWrapper<OnlineListings>;
  OnlineStatistic: ResolverTypeWrapper<OnlineStatistic>;
  OpenPsiResponse: ResolverTypeWrapper<OpenPsiResponse>;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationInput: OrganizationInput;
  PageInfo: PageInfo;
  PageInfoConfig: ResolverTypeWrapper<PageInfoConfig>;
  PageInfoConfigInput: PageInfoConfigInput;
  PaginatedDocumentResponse: ResolverTypeWrapper<PaginatedDocumentResponse>;
  PaginationControls: PaginationControls;
  PastSale: ResolverTypeWrapper<PastSale>;
  PastSearch: ResolverTypeWrapper<PastSearch>;
  PathConfig: ResolverTypeWrapper<PathConfig>;
  PathConfigInput: PathConfigInput;
  PdfColumn: PdfColumn;
  PdfRow: PdfRow;
  PendingSuccess: PendingSuccess;
  PermissionItem: ResolverTypeWrapper<PermissionItem>;
  Photo: ResolverTypeWrapper<Photo>;
  Profile: ResolverTypeWrapper<Profile>;
  Psi: ResolverTypeWrapper<Psi>;
  PsiFilter: PsiFilter;
  PsiNote: ResolverTypeWrapper<PsiNote>;
  PullVehicleRequest: PullVehicleRequest;
  PushVehicleToAmsResults: ResolverTypeWrapper<PushVehicleToAmsResults>;
  PushVehiclesToAmsResults: ResolverTypeWrapper<PushVehiclesToAmsResults>;
  Query: ResolverTypeWrapper<{}>;
  QueryAgentResponse: ResolverTypeWrapper<QueryAgentResponse>;
  QueryEventsListResponse: ResolverTypeWrapper<QueryEventsListResponse>;
  QueryResponse: ResolverTypeWrapper<QueryResponse>;
  QueryRunListResponse: ResolverTypeWrapper<QueryRunListResponse>;
  RegisterBidderDetails: RegisterBidderDetails;
  RegisterBidderResponse: ResolverTypeWrapper<RegisterBidderResponse>;
  Report: ResolverTypeWrapper<Report>;
  ReportColumn: ResolverTypeWrapper<ReportColumn>;
  ReportColumnInput: ReportColumnInput;
  ReportConfig: ResolverTypeWrapper<ReportConfig>;
  ReportDateOffset: ResolverTypeWrapper<ReportDateOffset>;
  ReportDetailPage: ResolverTypeWrapper<ReportDetailPage>;
  ReportFilter: ReportFilter;
  ReportSearchFilter: ResolverTypeWrapper<ReportSearchFilter>;
  ResendUnconfirmedPasswordInput: ResendUnconfirmedPasswordInput;
  ResetPasswordByEmailInput: ResetPasswordByEmailInput;
  ResetPasswordByEmailResponse: ResolverTypeWrapper<ResetPasswordByEmailResponse>;
  ReverseSaleRequest: ReverseSaleRequest;
  Role: ResolverTypeWrapper<Role>;
  RoleAttributes: ResolverTypeWrapper<RoleAttributes>;
  RunListFilter: RunListFilter;
  SEARCH_SORT_TYPES: Search_Sort_Types;
  SEARCH_TYPES: Search_Types;
  SORT_DIRECTION: Sort_Direction;
  SaleEvent: ResolverTypeWrapper<SaleEvent>;
  SaleListing: ResolverTypeWrapper<SaleListing>;
  SalesDayStatistics: ResolverTypeWrapper<SalesDayStatistics>;
  SearchAccount: ResolverTypeWrapper<SearchAccount>;
  SearchAgent: ResolverTypeWrapper<SearchAgent>;
  SearchBidder: ResolverTypeWrapper<SearchBidder>;
  SearchConfigInput: SearchConfigInput;
  SearchContactLog: ResolverTypeWrapper<SearchContactLog>;
  SearchFilter: SearchFilter;
  SearchPageInfo: SearchPageInfo;
  SearchResults: ResolverTypeWrapper<SearchResults>;
  SearchSort: SearchSort;
  SearchVehicle: ResolverTypeWrapper<SearchVehicle>;
  Service: ResolverTypeWrapper<Service>;
  ServiceResponse: ResolverTypeWrapper<ServiceResponse>;
  SetAnnouncements: SetAnnouncements;
  SetFloorPrice: SetFloorPrice;
  SetLights: SetLights;
  SetVehicleInfoResults: ResolverTypeWrapper<SetVehicleInfoResults>;
  ShareReportResponse: ResolverTypeWrapper<ShareReportResponse>;
  SinglePushVehicleToAmsResult: ResolverTypeWrapper<SinglePushVehicleToAmsResult>;
  Site: ResolverTypeWrapper<Site>;
  SortColumn: ResolverTypeWrapper<SortColumn>;
  SortColumnInput: SortColumnInput;
  SparkPaginatedResponse: ResolversTypes['QueryRunListResponse'];
  SparkResponse: ResolversTypes['CreatedEventResponse'] | ResolversTypes['MutationResponse'] | ResolversTypes['QueryAgentResponse'] | ResolversTypes['QueryEventsListResponse'] | ResolversTypes['QueryResponse'] | ResolversTypes['ShareReportResponse'] | ResolversTypes['UpateAllListingsMutationResponse'];
  StartBidTier: ResolverTypeWrapper<StartBidTier>;
  StartBidTierInput: StartBidTierInput;
  StatisticsFilter: StatisticsFilter;
  String: ResolverTypeWrapper<Scalars['String']>;
  TestVehicleAuditLog: ResolverTypeWrapper<TestVehicleAuditLog>;
  TrendInfo: ResolverTypeWrapper<TrendInfo>;
  Trends: ResolverTypeWrapper<Trends>;
  TrendsFilter: TrendsFilter;
  USER_TYPES: User_Types;
  UpateAllListingsMutationResponse: ResolverTypeWrapper<UpateAllListingsMutationResponse>;
  UpdateAgentContact: UpdateAgentContact;
  UpdateAllVenueAssets: UpdateAllVenueAssets;
  UpdateDocumentInput: UpdateDocumentInput;
  UpdateDocumentsResponse: ResolverTypeWrapper<UpdateDocumentsResponse>;
  UpdateFavoritesInput: UpdateFavoritesInput;
  UpdateRoles: UpdateRoles;
  UpdateUserInput: UpdateUserInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  User: ResolverTypeWrapper<User>;
  UserAttributes: ResolverTypeWrapper<UserAttributes>;
  UserAttributesInput: UserAttributesInput;
  UserMutationResponse: ResolverTypeWrapper<UserMutationResponse>;
  UserPermissions: ResolverTypeWrapper<UserPermissions>;
  VdpByStockNumberResults: ResolverTypeWrapper<VdpByStockNumberResults>;
  VehicleAMSResponse: ResolverTypeWrapper<VehicleAmsResponse>;
  VehicleDataTypes: ResolversTypes['OnlineListing'] | ResolversTypes['SearchVehicle'] | ResolversTypes['VehicleStatsByCompany'];
  VehicleStats: ResolverTypeWrapper<VehicleStats>;
  VehicleStatsByCompany: ResolverTypeWrapper<VehicleStatsByCompany>;
  VehiclesWithDocsResponse: ResolverTypeWrapper<VehiclesWithDocsResponse>;
  VenueEvent: ResolverTypeWrapper<VenueEvent>;
  VenueSaleListingAsset: ResolverTypeWrapper<VenueSaleListingAsset>;
  VenueSaleListingAssetInput: VenueSaleListingAssetInput;
  ViewType: ViewType;
  Watcher: ResolverTypeWrapper<Watcher>;
  pushToAMSResponse: ResolverTypeWrapper<PushToAmsResponse>;
  pushToAMSResposeResult: ResolverTypeWrapper<PushToAmsResposeResult>;
  sendMessageStatus: ResolverTypeWrapper<SendMessageStatus>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AMSUpdateResponseMessages: AmsUpdateResponseMessages;
  Account: Account;
  AccountGroupAccounts: AccountGroupAccounts;
  AccountGroupUsers: AccountGroupUsers;
  AccountGroups: AccountGroups;
  AccountGroupsFilter: AccountGroupsFilter;
  AccountNote: AccountNote;
  AccountSortBy: AccountSortBy;
  Accounts: Accounts;
  AccountsFilter: AccountsFilter;
  AdminInput: AdminInput;
  AdminInputSub: AdminInputSub;
  Administrator: Administrator;
  Agent: Agent;
  AgentCompany: AgentCompany;
  AgentDealerResponse: AgentDealerResponse;
  AgentNote: AgentNote;
  AgentNoteType: AgentNoteType;
  AgentNoteUpdate: AgentNoteUpdate;
  AgentNoteUpdateResult: AgentNoteUpdateResult;
  AgentRole: AgentRole;
  AgentRoleAction: AgentRoleAction;
  AgentRoleUpdate: AgentRoleUpdate;
  AgentRoleUpdateResult: AgentRoleUpdateResult;
  AgentRoleUpdateResults: AgentRoleUpdateResults;
  Agents: Agents;
  AgentsFilter: AgentsFilter;
  AmsCallResult: AmsCallResult;
  AmsResponse: AmsResponse;
  Announcement: Announcement;
  Asset: Asset;
  AssetFees: AssetFees;
  AssetFilter: AssetFilter;
  Assets: Assets;
  Attendance: Attendance;
  AttendanceList: AttendanceList;
  Auction: Auction;
  AuctionAmsInfo: AuctionAmsInfo;
  AuctionCollection: AuctionCollection;
  AuctionKey: AuctionKey;
  AuctionSettings: AuctionSettings;
  AuctionSettingsInput: AuctionSettingsInput;
  AuctionSettingsResponse: AuctionSettingsResponse;
  AuctionStatistics: AuctionStatistics;
  Audit: Audit;
  AuditInput: AuditInput;
  AuditResponse: AuditResponse;
  Bidder: Bidder;
  BidderList: BidderList;
  BiddersFilter: BiddersFilter;
  BiddingStatistics: BiddingStatistics;
  Boolean: Scalars['Boolean'];
  BuyNowTier: BuyNowTier;
  BuyNowTierInput: BuyNowTierInput;
  CacheShape: CacheShape;
  CalculatedIfOfferData: CalculatedIfOfferData;
  CancelProxyBidsResult: CancelProxyBidsResult;
  Card: Card;
  CardFilter: CardFilter;
  CompaniesList: CompaniesList;
  ConditionReport: ConditionReport;
  ConfigSearchResults: Omit<ConfigSearchResults, 'vehicleData'> & { vehicleData?: Maybe<Array<Maybe<ResolversParentTypes['VehicleDataTypes']>>> };
  Contact: Contact;
  ContactFilter: ContactFilter;
  ContactList: ContactList;
  ContactLogStats: ContactLogStats;
  ContactManagement: ContactManagement;
  ContactSortBy: ContactSortBy;
  ContactStatus: ContactStatus;
  ContactType: ContactType;
  CreateAgentContact: CreateAgentContact;
  CreateDocumentInput: CreateDocumentInput;
  CreateDocumentOutputAsset: CreateDocumentOutputAsset;
  CreateDocumentUploadDoc: CreateDocumentUploadDoc;
  CreateDocumentsInputAsset: CreateDocumentsInputAsset;
  CreateDocumentsUploadItem: CreateDocumentsUploadItem;
  CreateReportConfigInput: CreateReportConfigInput;
  CreateReportConfigResponse: CreateReportConfigResponse;
  CreateUserInput: CreateUserInput;
  CreateVenueEvent: CreateVenueEvent;
  CreatedEventResponse: CreatedEventResponse;
  CurrentSale: CurrentSale;
  CurrentSaleInput: CurrentSaleInput;
  Dashboard: Dashboard;
  DashboardCardInput: DashboardCardInput;
  DashboardFilter: DashboardFilter;
  DashboardInput: DashboardInput;
  Dashboards: Dashboards;
  DataConfig: DataConfig;
  DateRange: DateRange;
  Deal: Deal;
  DealFilter: DealFilter;
  Dealer: Dealer;
  DeleteAgentContact: DeleteAgentContact;
  DeleteUserInput: DeleteUserInput;
  DocType: DocType;
  Document: Document;
  DocumentActivity: DocumentActivity;
  DocumentUploadURL: DocumentUploadUrl;
  DocumentUploadURLsFilter: DocumentUploadUrLsFilter;
  DocumentView: DocumentView;
  DocumentsFilter: DocumentsFilter;
  EventTypeTrigger: EventTypeTrigger;
  EventsListFilter: EventsListFilter;
  ExitVehicleRequest: ExitVehicleRequest;
  ExpectedAnnouncement: ExpectedAnnouncement;
  Float: Scalars['Float'];
  FullSearch: FullSearch;
  GenerateOptions: GenerateOptions;
  GeneratePDFInput: GeneratePdfInput;
  GenericCard: GenericCard;
  GetSingleUserInput: GetSingleUserInput;
  GetUserListInput: GetUserListInput;
  HttpResponse: HttpResponse;
  ID: Scalars['ID'];
  IfOfferDetails: IfOfferDetails;
  IfOfferFilter: IfOfferFilter;
  IfOfferHistory: IfOfferHistory;
  IfOfferManagement: IfOfferManagement;
  IfOfferNotes: IfOfferNotes;
  IfOfferUpdateAMSResponse: IfOfferUpdateAmsResponse;
  IfOfferUpdateResult: IfOfferUpdateResult;
  IfOfferUpdateResults: IfOfferUpdateResults;
  InspectionInput: InspectionInput;
  InspectionType: InspectionType;
  InspectionTypeFilter: InspectionTypeFilter;
  Int: Scalars['Int'];
  Lane: Lane;
  LaneList: LaneList;
  LightOption: LightOption;
  ListView: ListView;
  ListViewConfigInput: ListViewConfigInput;
  LocalCreateDocumentInput: LocalCreateDocumentInput;
  LocalCreateDocumentOutput: LocalCreateDocumentOutput;
  LocalUploadDocumentInput: LocalUploadDocumentInput;
  Location: Location;
  LoginCredentials: LoginCredentials;
  LoginResponse: LoginResponse;
  MaintenanceDetails: MaintenanceDetails;
  MaintenanceUpdateResult: MaintenanceUpdateResult;
  Marketplace: Marketplace;
  MarketplaceStatistics: MarketplaceStatistics;
  MessageInput: MessageInput;
  MutateAccountGroupFilter: MutateAccountGroupFilter;
  Mutation: {};
  MutationDataResponse: ResolversParentTypes['VenueEvent'] | ResolversParentTypes['VenueSaleListingAsset'];
  MutationResponse: Omit<MutationResponse, 'data'> & { data?: Maybe<ResolversParentTypes['MutationDataResponse']> };
  NoSaleHistory: NoSaleHistory;
  NoSaleRequest: NoSaleRequest;
  NumberRange: NumberRange;
  OnlineListing: OnlineListing;
  OnlineListingFilter: OnlineListingFilter;
  OnlineListings: OnlineListings;
  OnlineStatistic: OnlineStatistic;
  OpenPsiResponse: OpenPsiResponse;
  Organization: Organization;
  OrganizationInput: OrganizationInput;
  PageInfo: PageInfo;
  PageInfoConfig: PageInfoConfig;
  PageInfoConfigInput: PageInfoConfigInput;
  PaginatedDocumentResponse: PaginatedDocumentResponse;
  PaginationControls: PaginationControls;
  PastSale: PastSale;
  PastSearch: PastSearch;
  PathConfig: PathConfig;
  PathConfigInput: PathConfigInput;
  PdfColumn: PdfColumn;
  PdfRow: PdfRow;
  PermissionItem: PermissionItem;
  Photo: Photo;
  Profile: Profile;
  Psi: Psi;
  PsiFilter: PsiFilter;
  PsiNote: PsiNote;
  PullVehicleRequest: PullVehicleRequest;
  PushVehicleToAmsResults: PushVehicleToAmsResults;
  PushVehiclesToAmsResults: PushVehiclesToAmsResults;
  Query: {};
  QueryAgentResponse: QueryAgentResponse;
  QueryEventsListResponse: QueryEventsListResponse;
  QueryResponse: QueryResponse;
  QueryRunListResponse: QueryRunListResponse;
  RegisterBidderDetails: RegisterBidderDetails;
  RegisterBidderResponse: RegisterBidderResponse;
  Report: Report;
  ReportColumn: ReportColumn;
  ReportColumnInput: ReportColumnInput;
  ReportConfig: ReportConfig;
  ReportDateOffset: ReportDateOffset;
  ReportDetailPage: ReportDetailPage;
  ReportFilter: ReportFilter;
  ReportSearchFilter: ReportSearchFilter;
  ResendUnconfirmedPasswordInput: ResendUnconfirmedPasswordInput;
  ResetPasswordByEmailInput: ResetPasswordByEmailInput;
  ResetPasswordByEmailResponse: ResetPasswordByEmailResponse;
  ReverseSaleRequest: ReverseSaleRequest;
  Role: Role;
  RoleAttributes: RoleAttributes;
  RunListFilter: RunListFilter;
  SaleEvent: SaleEvent;
  SaleListing: SaleListing;
  SalesDayStatistics: SalesDayStatistics;
  SearchAccount: SearchAccount;
  SearchAgent: SearchAgent;
  SearchBidder: SearchBidder;
  SearchConfigInput: SearchConfigInput;
  SearchContactLog: SearchContactLog;
  SearchFilter: SearchFilter;
  SearchPageInfo: SearchPageInfo;
  SearchResults: SearchResults;
  SearchSort: SearchSort;
  SearchVehicle: SearchVehicle;
  Service: Service;
  ServiceResponse: ServiceResponse;
  SetAnnouncements: SetAnnouncements;
  SetFloorPrice: SetFloorPrice;
  SetLights: SetLights;
  SetVehicleInfoResults: SetVehicleInfoResults;
  ShareReportResponse: ShareReportResponse;
  SinglePushVehicleToAmsResult: SinglePushVehicleToAmsResult;
  Site: Site;
  SortColumn: SortColumn;
  SortColumnInput: SortColumnInput;
  SparkPaginatedResponse: ResolversParentTypes['QueryRunListResponse'];
  SparkResponse: ResolversParentTypes['CreatedEventResponse'] | ResolversParentTypes['MutationResponse'] | ResolversParentTypes['QueryAgentResponse'] | ResolversParentTypes['QueryEventsListResponse'] | ResolversParentTypes['QueryResponse'] | ResolversParentTypes['ShareReportResponse'] | ResolversParentTypes['UpateAllListingsMutationResponse'];
  StartBidTier: StartBidTier;
  StartBidTierInput: StartBidTierInput;
  StatisticsFilter: StatisticsFilter;
  String: Scalars['String'];
  TestVehicleAuditLog: TestVehicleAuditLog;
  TrendInfo: TrendInfo;
  Trends: Trends;
  TrendsFilter: TrendsFilter;
  UpateAllListingsMutationResponse: UpateAllListingsMutationResponse;
  UpdateAgentContact: UpdateAgentContact;
  UpdateAllVenueAssets: UpdateAllVenueAssets;
  UpdateDocumentInput: UpdateDocumentInput;
  UpdateDocumentsResponse: UpdateDocumentsResponse;
  UpdateFavoritesInput: UpdateFavoritesInput;
  UpdateRoles: UpdateRoles;
  UpdateUserInput: UpdateUserInput;
  Upload: Scalars['Upload'];
  User: User;
  UserAttributes: UserAttributes;
  UserAttributesInput: UserAttributesInput;
  UserMutationResponse: UserMutationResponse;
  UserPermissions: UserPermissions;
  VdpByStockNumberResults: VdpByStockNumberResults;
  VehicleAMSResponse: VehicleAmsResponse;
  VehicleDataTypes: ResolversParentTypes['OnlineListing'] | ResolversParentTypes['SearchVehicle'] | ResolversParentTypes['VehicleStatsByCompany'];
  VehicleStats: VehicleStats;
  VehicleStatsByCompany: VehicleStatsByCompany;
  VehiclesWithDocsResponse: VehiclesWithDocsResponse;
  VenueEvent: VenueEvent;
  VenueSaleListingAsset: VenueSaleListingAsset;
  VenueSaleListingAssetInput: VenueSaleListingAssetInput;
  Watcher: Watcher;
  pushToAMSResponse: PushToAmsResponse;
  pushToAMSResposeResult: PushToAmsResposeResult;
  sendMessageStatus: SendMessageStatus;
}>;

export type Aws_Api_KeyDirectiveArgs = { };

export type Aws_Api_KeyDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_Api_KeyDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_AuthDirectiveArgs = {
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_AuthDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_AuthDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_Cognito_User_PoolsDirectiveArgs = {
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_Cognito_User_PoolsDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_Cognito_User_PoolsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_IamDirectiveArgs = { };

export type Aws_IamDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_IamDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_LambdaDirectiveArgs = { };

export type Aws_LambdaDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_LambdaDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_OidcDirectiveArgs = { };

export type Aws_OidcDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_OidcDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_PublishDirectiveArgs = {
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_PublishDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_PublishDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_SubscribeDirectiveArgs = {
  mutations?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_SubscribeDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_SubscribeDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type DeferDirectiveArgs = { };

export type DeferDirectiveResolver<Result, Parent, ContextType = any, Args = DeferDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AmsUpdateResponseMessagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AMSUpdateResponseMessages'] = ResolversParentTypes['AMSUpdateResponseMessages']> = ResolversObject<{
  error?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  warning?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = ResolversObject<{
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accountKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountNote']>>>, ParentType, ContextType>;
  accountOrgDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountOrgId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accountSalesRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agents?: Resolver<Maybe<ResolversTypes['Agents']>, ParentType, ContextType>;
  auctionAccessNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canBuy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canSell?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  establishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFavorite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastAttended?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastPurchaseActivity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSoldActivity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Location']>>>, ParentType, ContextType>;
  orgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneMain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneSecondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountGroupAccountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountGroupAccounts'] = ResolversParentTypes['AccountGroupAccounts']> = ResolversObject<{
  accountGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountGroupUsersResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountGroupUsers'] = ResolversParentTypes['AccountGroupUsers']> = ResolversObject<{
  accountGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isOwner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountGroupsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountGroups'] = ResolversParentTypes['AccountGroups']> = ResolversObject<{
  accounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountGroupAccounts']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShared?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountGroupUsers']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountNote'] = ResolversParentTypes['AccountNote']> = ResolversObject<{
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Accounts'] = ResolversParentTypes['Accounts']> = ResolversObject<{
  byId?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  docsByDocTypeShortCode?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, Partial<AccountsDocsByDocTypeShortCodeArgs>>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Account']>>>, ParentType, ContextType, Partial<AccountsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AdministratorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Administrator'] = ResolversParentTypes['Administrator']> = ResolversObject<{
  allGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoleAttributes']>>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<AdministratorUserArgs, 'input'>>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserAttributes']>>>, ParentType, ContextType, RequireFields<AdministratorUsersArgs, 'input'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agent'] = ResolversParentTypes['Agent']> = ResolversObject<{
  accountAuctionAccessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountIssuerOrgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountNote']>>>, ParentType, ContextType>;
  agentAuthCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  agentNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attendanceHistory?: Resolver<Maybe<ResolversTypes['AttendanceList']>, ParentType, ContextType>;
  auctionAccessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionAccessPicture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bidderNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthday?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canBuy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canSell?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cellPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contacts?: Resolver<Maybe<ResolversTypes['ContactList']>, ParentType, ContextType>;
  dateAddedOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstAttendedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  homePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBadgeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBadgeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastPurchaseActivity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentNote']>>>, ParentType, ContextType>;
  online?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  otherCompanies?: Resolver<Maybe<ResolversTypes['CompaniesList']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentRole']>>>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentCompany'] = ResolversParentTypes['AgentCompany']> = ResolversObject<{
  accountDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentDealerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentDealerResponse'] = ResolversParentTypes['AgentDealerResponse']> = ResolversObject<{
  agent?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  dealer?: Resolver<Maybe<ResolversTypes['Dealer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentNote'] = ResolversParentTypes['AgentNote']> = ResolversObject<{
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sparkUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentNoteTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentNoteType'] = ResolversParentTypes['AgentNoteType']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentNoteUpdateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentNoteUpdateResult'] = ResolversParentTypes['AgentNoteUpdateResult']> = ResolversObject<{
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentRole'] = ResolversParentTypes['AgentRole']> = ResolversObject<{
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ordinal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentRoleUpdateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentRoleUpdateResult'] = ResolversParentTypes['AgentRoleUpdateResult']> = ResolversObject<{
  roleCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentRoleUpdateResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentRoleUpdateResults'] = ResolversParentTypes['AgentRoleUpdateResults']> = ResolversObject<{
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentRoleUpdateResult']>>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agents'] = ResolversParentTypes['Agents']> = ResolversObject<{
  byId?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agent']>>>, ParentType, ContextType, Partial<AgentsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmsCallResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmsCallResult'] = ResolversParentTypes['AmsCallResult']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmsResponse'] = ResolversParentTypes['AmsResponse']> = ResolversObject<{
  ifNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferNotes']>>>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AnnouncementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Announcement'] = ResolversParentTypes['Announcement']> = ResolversObject<{
  announcement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ordinal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeLongDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeShortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['Asset'] = ResolversParentTypes['Asset']> = ResolversObject<{
  announcements?: Resolver<Maybe<Array<Maybe<ResolversTypes['Announcement']>>>, ParentType, ContextType>;
  assetFees?: Resolver<Maybe<Array<Maybe<ResolversTypes['AssetFees']>>>, ParentType, ContextType>;
  assetId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  blackBookValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bodyStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  buyerAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPicture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkinDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkinTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkinUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditionReport?: Resolver<Maybe<ResolversTypes['ConditionReport']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  consignorAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  consignorAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorDbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  consignorLegalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorPipelineId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countAll?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  crStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerReferenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cylinderConfiguration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cylinders?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  drivetrain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  drivetrainDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  engineSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exteriorColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fuelType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grade?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ifOfferManagement?: Resolver<Maybe<ResolversTypes['IfOfferManagement']>, ParentType, ContextType>;
  interiorColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingCondition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingConditionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingConditionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mmrValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  odometer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onlineListing?: Resolver<Maybe<ResolversTypes['OnlineListing']>, ParentType, ContextType>;
  ownerStockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photoBeauty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photoCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  photos?: Resolver<Maybe<Array<Maybe<ResolversTypes['Photo']>>>, ParentType, ContextType>;
  pipelineUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pmrValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  proxyBidCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['SaleEvent']>>>, ParentType, ContextType>;
  saleListing?: Resolver<Maybe<ResolversTypes['SaleListing']>, ParentType, ContextType>;
  saleListingDealSoldAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingLane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingLot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingOfferCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingSaleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingSaleStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingSoldDateLastRanTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingVenueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingVenueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingVenueUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  services?: Resolver<Maybe<Array<Maybe<ResolversTypes['Service']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleReceivedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transmissionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trim?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetFeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetFees'] = ResolversParentTypes['AssetFees']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Assets'] = ResolversParentTypes['Assets']> = ResolversObject<{
  assetsByStockNumber?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType>;
  byId?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType>;
  byStockNumber?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Asset']>>>, ParentType, ContextType, Partial<AssetsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttendanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attendance'] = ResolversParentTypes['Attendance']> = ResolversObject<{
  attendanceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bidderBadgeNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttendanceListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttendanceList'] = ResolversParentTypes['AttendanceList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Attendance']>>>, ParentType, ContextType, Partial<AttendanceListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Auction'] = ResolversParentTypes['Auction']> = ResolversObject<{
  accounts?: Resolver<Maybe<ResolversTypes['Accounts']>, ParentType, ContextType, RequireFields<AuctionAccountsArgs, 'filter'>>;
  agentNoteTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentNoteType']>>>, ParentType, ContextType>;
  agentRoles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentRole']>>>, ParentType, ContextType>;
  agents?: Resolver<Maybe<ResolversTypes['Agents']>, ParentType, ContextType, RequireFields<AuctionAgentsArgs, 'filter'>>;
  amsInfo?: Resolver<Maybe<ResolversTypes['AuctionAmsInfo']>, ParentType, ContextType>;
  assets?: Resolver<Maybe<ResolversTypes['Assets']>, ParentType, ContextType, RequireFields<AuctionAssetsArgs, 'filter'>>;
  auctionSettings?: Resolver<Maybe<ResolversTypes['AuctionSettingsResponse']>, ParentType, ContextType, Partial<AuctionAuctionSettingsArgs>>;
  card?: Resolver<Maybe<ResolversTypes['GenericCard']>, ParentType, ContextType, Partial<AuctionCardArgs>>;
  contactManagement?: Resolver<Maybe<ResolversTypes['ContactManagement']>, ParentType, ContextType>;
  document?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType>;
  getDownloadLink?: Resolver<Maybe<ResolversTypes['ShareReportResponse']>, ParentType, ContextType, Partial<AuctionGetDownloadLinkArgs>>;
  getReportConfig?: Resolver<Maybe<ResolversTypes['ReportConfig']>, ParentType, ContextType, Partial<AuctionGetReportConfigArgs>>;
  getReportConfigs?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportConfig']>>>, ParentType, ContextType, Partial<AuctionGetReportConfigsArgs>>;
  groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountGroups']>>>, ParentType, ContextType, Partial<AuctionGroupsArgs>>;
  keys?: Resolver<Maybe<ResolversTypes['VdpByStockNumberResults']>, ParentType, ContextType, Partial<AuctionKeysArgs>>;
  lightOptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['LightOption']>>>, ParentType, ContextType>;
  marketplace?: Resolver<Maybe<ResolversTypes['Marketplace']>, ParentType, ContextType>;
  psi?: Resolver<Maybe<ResolversTypes['Psi']>, ParentType, ContextType, Partial<AuctionPsiArgs>>;
  reportDetailPages?: Resolver<Array<ResolversTypes['ReportDetailPage']>, ParentType, ContextType>;
  reports?: Resolver<Maybe<Array<Maybe<ResolversTypes['Report']>>>, ParentType, ContextType, RequireFields<AuctionReportsArgs, 'filter'>>;
  roles?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoleAttributes']>>>, ParentType, ContextType>;
  search?: Resolver<Maybe<ResolversTypes['SearchResults']>, ParentType, ContextType, Partial<AuctionSearchArgs>>;
  setVehicleInfo?: Resolver<Maybe<ResolversTypes['SetVehicleInfoResults']>, ParentType, ContextType, RequireFields<AuctionSetVehicleInfoArgs, 'assetId' | 'stockNumber'>>;
  statistics?: Resolver<Maybe<ResolversTypes['AuctionStatistics']>, ParentType, ContextType, Partial<AuctionStatisticsArgs>>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserAttributes']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAmsInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuctionAmsInfo'] = ResolversParentTypes['AuctionAmsInfo']> = ResolversObject<{
  lightValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuctionCollection'] = ResolversParentTypes['AuctionCollection']> = ResolversObject<{
  accounts?: Resolver<Maybe<ResolversTypes['Accounts']>, ParentType, ContextType, RequireFields<AuctionCollectionAccountsArgs, 'filter'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionKeyResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuctionKey'] = ResolversParentTypes['AuctionKey']> = ResolversObject<{
  accountingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pipelineId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuctionSettings'] = ResolversParentTypes['AuctionSettings']> = ResolversObject<{
  bidIncrement?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  buyNowTiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuyNowTier']>>>, ParentType, ContextType>;
  enforceConditionReport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enforceFloorPrice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enforceGrade?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enforceLight?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nonAdminEditBidIncrement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nonAdminEditFloorPrice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  offerThreshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startBidTiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['StartBidTier']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionSettingsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuctionSettingsResponse'] = ResolversParentTypes['AuctionSettingsResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['AuctionSettings']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionStatisticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuctionStatistics'] = ResolversParentTypes['AuctionStatistics']> = ResolversObject<{
  bidders?: Resolver<Maybe<ResolversTypes['BidderList']>, ParentType, ContextType, RequireFields<AuctionStatisticsBiddersArgs, 'filter'>>;
  biddingStatistics?: Resolver<Maybe<ResolversTypes['BiddingStatistics']>, ParentType, ContextType>;
  lanes?: Resolver<Maybe<ResolversTypes['LaneList']>, ParentType, ContextType>;
  saleStatistics?: Resolver<Maybe<ResolversTypes['SalesDayStatistics']>, ParentType, ContextType>;
  trends?: Resolver<Maybe<ResolversTypes['Trends']>, ParentType, ContextType, RequireFields<AuctionStatisticsTrendsArgs, 'filter'>>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuditResolvers<ContextType = any, ParentType extends ResolversParentTypes['Audit'] = ResolversParentTypes['Audit']> = ResolversObject<{
  getVehicleAuditList?: Resolver<Maybe<ResolversTypes['AuditResponse']>, ParentType, ContextType, Partial<AuditGetVehicleAuditListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuditResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditResponse'] = ResolversParentTypes['AuditResponse']> = ResolversObject<{
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['TestVehicleAuditLog']>>>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BidderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bidder'] = ResolversParentTypes['Bidder']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountOrgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  badge?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BidderListResolvers<ContextType = any, ParentType extends ResolversParentTypes['BidderList'] = ResolversParentTypes['BidderList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Bidder']>>>, ParentType, ContextType, Partial<BidderListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BiddingStatisticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BiddingStatistics'] = ResolversParentTypes['BiddingStatistics']> = ResolversObject<{
  inlaneBidders?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  onlineBidders?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalBidders?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BuyNowTierResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyNowTier'] = ResolversParentTypes['BuyNowTier']> = ResolversObject<{
  amountAbovePriceFloor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceFloorLBound?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceFloorUBound?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CacheShapeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CacheShape'] = ResolversParentTypes['CacheShape']> = ResolversObject<{
  mutation?: Resolver<Maybe<ResolversTypes['Mutation']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CalculatedIfOfferDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalculatedIfOfferData'] = ResolversParentTypes['CalculatedIfOfferData']> = ResolversObject<{
  buyerMovementThisOffer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerNotesThisOffer?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  sellerMovementThisOffer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerNotesThisOffer?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelProxyBidsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelProxyBidsResult'] = ResolversParentTypes['CancelProxyBidsResult']> = ResolversObject<{
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CardResolvers<ContextType = any, ParentType extends ResolversParentTypes['Card'] = ResolversParentTypes['Card']> = ResolversObject<{
  config?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompaniesListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompaniesList'] = ResolversParentTypes['CompaniesList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentCompany']>>>, ParentType, ContextType, Partial<CompaniesListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConditionReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConditionReport'] = ResolversParentTypes['ConditionReport']> = ResolversObject<{
  conditionReportStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditionReportTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditionReportWriter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigSearchResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigSearchResults'] = ResolversParentTypes['ConfigSearchResults']> = ResolversObject<{
  searchStringDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleData?: Resolver<Maybe<Array<Maybe<ResolversTypes['VehicleDataTypes']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contact'] = ResolversParentTypes['Contact']> = ResolversObject<{
  account?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerSellerAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contactedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followUpDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followUpUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  followupUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactList'] = ResolversParentTypes['ContactList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Contact']>>>, ParentType, ContextType, Partial<ContactListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactLogStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactLogStats'] = ResolversParentTypes['ContactLogStats']> = ResolversObject<{
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactManagementResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactManagement'] = ResolversParentTypes['ContactManagement']> = ResolversObject<{
  contacts?: Resolver<Maybe<ResolversTypes['ContactList']>, ParentType, ContextType, Partial<ContactManagementContactsArgs>>;
  statuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['ContactStatus']>>>, ParentType, ContextType>;
  types?: Resolver<Maybe<Array<Maybe<ResolversTypes['ContactType']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactStatus'] = ResolversParentTypes['ContactStatus']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactType'] = ResolversParentTypes['ContactType']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateDocumentOutputAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDocumentOutputAsset'] = ResolversParentTypes['CreateDocumentOutputAsset']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  docTypeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  docTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docTypeShortCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateDocumentUploadDocResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDocumentUploadDoc'] = ResolversParentTypes['CreateDocumentUploadDoc']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  docId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3PresignedUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateDocumentsUploadItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDocumentsUploadItem'] = ResolversParentTypes['CreateDocumentsUploadItem']> = ResolversObject<{
  asset?: Resolver<Maybe<ResolversTypes['CreateDocumentOutputAsset']>, ParentType, ContextType>;
  doc?: Resolver<Maybe<ResolversTypes['CreateDocumentUploadDoc']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateReportConfigResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateReportConfigResponse'] = ResolversParentTypes['CreateReportConfigResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreatedEventResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatedEventResponse'] = ResolversParentTypes['CreatedEventResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CurrentSaleResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentSale'] = ResolversParentTypes['CurrentSale']> = ResolversObject<{
  asset_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venue_event_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venue_event_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DashboardResolvers<ContextType = any, ParentType extends ResolversParentTypes['Dashboard'] = ResolversParentTypes['Dashboard']> = ResolversObject<{
  cards?: Resolver<Maybe<Array<Maybe<ResolversTypes['Card']>>>, ParentType, ContextType>;
  configJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  databaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DashboardsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Dashboards'] = ResolversParentTypes['Dashboards']> = ResolversObject<{
  byId?: Resolver<Maybe<ResolversTypes['Dashboard']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Dashboard']>>>, ParentType, ContextType, Partial<DashboardsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DataConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataConfig'] = ResolversParentTypes['DataConfig']> = ResolversObject<{
  dataFilter?: Resolver<Maybe<ResolversTypes['ReportSearchFilter']>, ParentType, ContextType>;
  dataSource?: Resolver<Maybe<ResolversTypes['DataSourceTypes']>, ParentType, ContextType>;
  pageInfo?: Resolver<Maybe<ResolversTypes['PageInfoConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealResolvers<ContextType = any, ParentType extends ResolversParentTypes['Deal'] = ResolversParentTypes['Deal']> = ResolversObject<{
  buyer?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  currentOfferAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListing?: Resolver<Maybe<ResolversTypes['SaleListing']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Dealer'] = ResolversParentTypes['Dealer']> = ResolversObject<{
  dealerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocType'] = ResolversParentTypes['DocType']> = ResolversObject<{
  displayOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  docTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  docTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  docTypeNameUnderscored?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verticalTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  buyerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAtFormatted?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentSaleListingDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  displayOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  docId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  docName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  docTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  docTypeNameUnderscored?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docTypeShortCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentActivity?: Resolver<Maybe<ResolversTypes['DocumentActivity']>, ParentType, ContextType, RequireFields<DocumentDocumentActivityArgs, 'docId'>>;
  documentByDocId?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<DocumentDocumentByDocIdArgs, 'filter'>>;
  documentByDocTypeShortCode?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, RequireFields<DocumentDocumentByDocTypeShortCodeArgs, 'filter'>>;
  documentFilterLists?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, RequireFields<DocumentDocumentFilterListsArgs, 'filter'>>;
  documentLists?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, RequireFields<DocumentDocumentListsArgs, 'filter'>>;
  documentTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['DocType']>>>, ParentType, ContextType, RequireFields<DocumentDocumentTypesArgs, 'verticalTypeId'>>;
  documentUploadURLs?: Resolver<Maybe<Array<Maybe<ResolversTypes['DocumentUploadURL']>>>, ParentType, ContextType, RequireFields<DocumentDocumentUploadUrLsArgs, 'filter'>>;
  documentsByAuctionFilter?: Resolver<Maybe<ResolversTypes['PaginatedDocumentResponse']>, ParentType, ContextType, RequireFields<DocumentDocumentsByAuctionFilterArgs, 'filter'>>;
  numNotes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  s3Url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3UrlDownload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3UrlExpires?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3UrlExpiresFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAtFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleMake?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleVIN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehiclesWithDocs?: Resolver<Maybe<ResolversTypes['VehiclesWithDocsResponse']>, ParentType, ContextType, Partial<DocumentVehiclesWithDocsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentActivity'] = ResolversParentTypes['DocumentActivity']> = ResolversObject<{
  documentViews?: Resolver<Maybe<Array<Maybe<ResolversTypes['DocumentView']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentUploadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentUploadURL'] = ResolversParentTypes['DocumentUploadURL']> = ResolversObject<{
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  urlExpires?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentView'] = ResolversParentTypes['DocumentView']> = ResolversObject<{
  docId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userType?: Resolver<Maybe<ResolversTypes['USER_TYPES']>, ParentType, ContextType>;
  viewedAt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EventTypeTriggerResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventTypeTrigger'] = ResolversParentTypes['EventTypeTrigger']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ordinal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenericCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericCard'] = ResolversParentTypes['GenericCard']> = ResolversObject<{
  vdpViewsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vdpViewsStats?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnlineStatistic']>>>, ParentType, ContextType>;
  watchedVehiclesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  watchedVehiclesList?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnlineListing']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HttpResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['HttpResponse'] = ResolversParentTypes['HttpResponse']> = ResolversObject<{
  statusCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['IfOfferHistory'] = ResolversParentTypes['IfOfferHistory']> = ResolversObject<{
  announcementLight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementLights?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetAnnouncementFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetAnnouncementOne?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetAnnouncementThree?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetAnnouncementTwo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ballControlCode?: Resolver<Maybe<ResolversTypes['BallControlCode']>, ParentType, ContextType>;
  ballControlDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyNowPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrSellerAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  correlationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentOfferAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currentOfferAmountPrevious?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventCreatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventCreatedById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventTriggerCode?: Resolver<Maybe<ResolversTypes['EventTriggerCode']>, ParentType, ContextType>;
  eventTriggerDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventTypeCode?: Resolver<Maybe<ResolversTypes['EventTypeCode']>, ParentType, ContextType>;
  eventTypeDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fees?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  floorPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isVirtualAuction?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  laneName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valuationBlackbookAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  valuationMMRAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferManagementResolvers<ContextType = any, ParentType extends ResolversParentTypes['IfOfferManagement'] = ResolversParentTypes['IfOfferManagement']> = ResolversObject<{
  buyerAgent?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  buyerAgents?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agent']>>>, ParentType, ContextType>;
  calculatedIfOfferData?: Resolver<Maybe<ResolversTypes['CalculatedIfOfferData']>, ParentType, ContextType>;
  eventTriggers?: Resolver<Maybe<Array<Maybe<ResolversTypes['EventTypeTrigger']>>>, ParentType, ContextType>;
  eventTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['EventTypeTrigger']>>>, ParentType, ContextType>;
  ifOfferHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferHistory']>>>, ParentType, ContextType>;
  noSaleHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['NoSaleHistory']>>>, ParentType, ContextType>;
  pastSalesHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['PastSale']>>>, ParentType, ContextType>;
  sellerAgent?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  sellerAgents?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agent']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferNotesResolvers<ContextType = any, ParentType extends ResolversParentTypes['IfOfferNotes'] = ResolversParentTypes['IfOfferNotes']> = ResolversObject<{
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['IfOfferNoteType'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferUpdateAmsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IfOfferUpdateAMSResponse'] = ResolversParentTypes['IfOfferUpdateAMSResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['AmsResponse']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<ResolversTypes['AMSUpdateResponseMessages']>, ParentType, ContextType>;
  responseCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferUpdateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IfOfferUpdateResult'] = ResolversParentTypes['IfOfferUpdateResult']> = ResolversObject<{
  amsStatusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amsStatusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ifNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferNotes']>>>, ParentType, ContextType>;
  lastOfferHistoryItem?: Resolver<Maybe<ResolversTypes['IfOfferHistory']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferUpdateResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IfOfferUpdateResults'] = ResolversParentTypes['IfOfferUpdateResults']> = ResolversObject<{
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferUpdateResult']>>>, ParentType, ContextType>;
  searchUpdateSuccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InspectionTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InspectionType'] = ResolversParentTypes['InspectionType']> = ResolversObject<{
  chargeAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  chargeAmountFail?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  chargeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultPrinterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longDesc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ordinal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  printOnCreate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quickPickLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quickPickOrdinal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  serviceClass?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDesc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InspectionTypeFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['InspectionTypeFilter'] = ResolversParentTypes['InspectionTypeFilter']> = ResolversObject<{
  amsServiceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargeAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orgCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceProductId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LaneResolvers<ContextType = any, ParentType extends ResolversParentTypes['Lane'] = ResolversParentTypes['Lane']> = ResolversObject<{
  arbitration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasCr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  offer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offerOnline?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  registered?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soldOnline?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  units?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LaneListResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaneList'] = ResolversParentTypes['LaneList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Lane']>>>, ParentType, ContextType, Partial<LaneListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LightOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LightOption'] = ResolversParentTypes['LightOption']> = ResolversObject<{
  amsValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lightCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lightDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lightId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListView'] = ResolversParentTypes['ListView']> = ResolversObject<{
  columns?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportColumn']>>>, ParentType, ContextType>;
  mobileColumns?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportColumn']>>>, ParentType, ContextType>;
  paths?: Resolver<Maybe<ResolversTypes['PathConfig']>, ParentType, ContextType>;
  shareSubject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateVars?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocalCreateDocumentOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalCreateDocumentOutput'] = ResolversParentTypes['LocalCreateDocumentOutput']> = ResolversObject<{
  docId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = ResolversObject<{
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoginResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginResponse'] = ResolversParentTypes['LoginResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<ResolversTypes['LoginResponseTypes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MaintenanceUpdateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MaintenanceUpdateResult'] = ResolversParentTypes['MaintenanceUpdateResult']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketplaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Marketplace'] = ResolversParentTypes['Marketplace']> = ResolversObject<{
  listings?: Resolver<Maybe<ResolversTypes['OnlineListings']>, ParentType, ContextType, Partial<MarketplaceListingsArgs>>;
  statistics?: Resolver<Maybe<ResolversTypes['MarketplaceStatistics']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketplaceStatisticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketplaceStatistics'] = ResolversParentTypes['MarketplaceStatistics']> = ResolversObject<{
  activeListings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soldOnline?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  viewed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MarketplaceStatisticsViewedArgs>>;
  viewedByDate?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnlineStatistic']>>>, ParentType, ContextType, Partial<MarketplaceStatisticsViewedByDateArgs>>;
  watched?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  addAssetsToVenueEvent?: Resolver<Maybe<Array<Maybe<ResolversTypes['MutationResponse']>>>, ParentType, ContextType, Partial<MutationAddAssetsToVenueEventArgs>>;
  addDashboardCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAddDashboardCardArgs, 'card'>>;
  addPastSearch?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAddPastSearchArgs, 'input'>>;
  batchCreateDocument?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, RequireFields<MutationBatchCreateDocumentArgs, 'createDocumentInput'>>;
  beginEditingLayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  changeAuction?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationChangeAuctionArgs, 'newAuction'>>;
  changeDashboardName?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationChangeDashboardNameArgs, 'name'>>;
  closeAccessoryDrawer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  copyDashboard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCopyDashboardArgs, 'name'>>;
  copyDashboardCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCopyDashboardCardArgs, 'widgetId'>>;
  createAgentContact?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType, RequireFields<MutationCreateAgentContactArgs, 'input'>>;
  createDashboard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCreateDashboardArgs, 'name'>>;
  createDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreateDocumentsUploadItem']>>>, ParentType, ContextType, RequireFields<MutationCreateDocumentsArgs, 'auctionId'>>;
  createDocumentsClient?: Resolver<Maybe<Array<Maybe<ResolversTypes['LocalCreateDocumentOutput']>>>, ParentType, ContextType, RequireFields<MutationCreateDocumentsClientArgs, 'docs'>>;
  createPSI?: Resolver<Maybe<ResolversTypes['OpenPsiResponse']>, ParentType, ContextType, Partial<MutationCreatePsiArgs>>;
  createReportConfig?: Resolver<Maybe<ResolversTypes['CreateReportConfigResponse']>, ParentType, ContextType, Partial<MutationCreateReportConfigArgs>>;
  createUser?: Resolver<Maybe<ResolversTypes['UserMutationResponse']>, ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'input'>>;
  createVenueEvent?: Resolver<Maybe<ResolversTypes['CreatedEventResponse']>, ParentType, ContextType, Partial<MutationCreateVenueEventArgs>>;
  deleteAgentContact?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteAgentContactArgs, 'id' | 'input'>>;
  deleteDashboard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationDeleteDashboardArgs>>;
  deleteDashboardCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteDashboardCardArgs, 'cardId'>>;
  deleteUser?: Resolver<Maybe<ResolversTypes['UserMutationResponse']>, ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'input'>>;
  deleteVenueEvent?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, Partial<MutationDeleteVenueEventArgs>>;
  doCompleteNewPassword?: Resolver<Maybe<ResolversTypes['LoginResponse']>, ParentType, ContextType, RequireFields<MutationDoCompleteNewPasswordArgs, 'newPassword'>>;
  doLogin?: Resolver<Maybe<ResolversTypes['LoginResponse']>, ParentType, ContextType, RequireFields<MutationDoLoginArgs, 'credentials'>>;
  doLogout?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  doResetPasswordByEmail?: Resolver<Maybe<ResolversTypes['ResetPasswordByEmailResponse']>, ParentType, ContextType, RequireFields<MutationDoResetPasswordByEmailArgs, 'email'>>;
  endEditingLayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  exitVehicle?: Resolver<Maybe<ResolversTypes['VehicleAMSResponse']>, ParentType, ContextType, RequireFields<MutationExitVehicleArgs, 'exitVehicleDetails'>>;
  generatePDF?: Resolver<Maybe<ResolversTypes['ShareReportResponse']>, ParentType, ContextType, Partial<MutationGeneratePdfArgs>>;
  generateUploadUrl?: Resolver<ResolversTypes['DocumentUploadURL'], ParentType, ContextType, RequireFields<MutationGenerateUploadUrlArgs, 'assetId'>>;
  noSale?: Resolver<Maybe<ResolversTypes['VehicleAMSResponse']>, ParentType, ContextType, RequireFields<MutationNoSaleArgs, 'noSaleDetails'>>;
  pullVehicle?: Resolver<Maybe<ResolversTypes['VehicleAMSResponse']>, ParentType, ContextType, RequireFields<MutationPullVehicleArgs, 'pullVehicleDetails'>>;
  pushToAMS?: Resolver<Maybe<ResolversTypes['pushToAMSResponse']>, ParentType, ContextType, RequireFields<MutationPushToAmsArgs, 'ids'>>;
  pushVehicleToAms?: Resolver<Maybe<ResolversTypes['PushVehicleToAmsResults']>, ParentType, ContextType, RequireFields<MutationPushVehicleToAmsArgs, 'id'>>;
  pushVehiclesToAms?: Resolver<Maybe<ResolversTypes['PushVehiclesToAmsResults']>, ParentType, ContextType, RequireFields<MutationPushVehiclesToAmsArgs, 'ids'>>;
  putMessage?: Resolver<Maybe<ResolversTypes['sendMessageStatus']>, ParentType, ContextType, Partial<MutationPutMessageArgs>>;
  registerBidder?: Resolver<Maybe<ResolversTypes['RegisterBidderResponse']>, ParentType, ContextType, RequireFields<MutationRegisterBidderArgs, 'bidderDetails'>>;
  removeAssetFromVenueEvent?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, Partial<MutationRemoveAssetFromVenueEventArgs>>;
  removeAssetsFromVenueEvent?: Resolver<Maybe<Array<Maybe<ResolversTypes['MutationResponse']>>>, ParentType, ContextType, Partial<MutationRemoveAssetsFromVenueEventArgs>>;
  removeDocument?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<MutationRemoveDocumentArgs, 'docId'>>;
  reorderUserDashboards?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationReorderUserDashboardsArgs, 'id' | 'index'>>;
  resendUnconfirmedPassword?: Resolver<Maybe<ResolversTypes['HttpResponse']>, ParentType, ContextType, RequireFields<MutationResendUnconfirmedPasswordArgs, 'input'>>;
  resetPasswordByEmail?: Resolver<Maybe<ResolversTypes['ResetPasswordByEmailResponse']>, ParentType, ContextType, RequireFields<MutationResetPasswordByEmailArgs, 'input'>>;
  reverseSale?: Resolver<Maybe<ResolversTypes['VehicleAMSResponse']>, ParentType, ContextType, RequireFields<MutationReverseSaleArgs, 'reverseSaleDetails'>>;
  saveLayouts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationSaveLayoutsArgs>>;
  setVehicleInfo?: Resolver<Maybe<ResolversTypes['SetVehicleInfoResults']>, ParentType, ContextType, RequireFields<MutationSetVehicleInfoArgs, 'amsType' | 'assetId' | 'floor' | 'selectedLightId' | 'stockNumber'>>;
  sharePdfCsv?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSharePdfCsvArgs, 'messageBody' | 'senderEmail' | 'senderName'>>;
  showAccessoryDrawer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationShowAccessoryDrawerArgs, 'input'>>;
  tempSaveLayouts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationTempSaveLayoutsArgs, 'layouts'>>;
  updateAgentContact?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType, RequireFields<MutationUpdateAgentContactArgs, 'id' | 'input'>>;
  updateAgentNote?: Resolver<Maybe<ResolversTypes['AgentNoteUpdateResult']>, ParentType, ContextType, Partial<MutationUpdateAgentNoteArgs>>;
  updateAgentRoles?: Resolver<Maybe<ResolversTypes['AgentRoleUpdateResults']>, ParentType, ContextType, Partial<MutationUpdateAgentRolesArgs>>;
  updateAllAssetsOnVenueEvent?: Resolver<Maybe<ResolversTypes['UpateAllListingsMutationResponse']>, ParentType, ContextType, Partial<MutationUpdateAllAssetsOnVenueEventArgs>>;
  updateAssetOnVenueEvent?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, Partial<MutationUpdateAssetOnVenueEventArgs>>;
  updateAssetsOnVenueEvent?: Resolver<Maybe<Array<Maybe<ResolversTypes['MutationResponse']>>>, ParentType, ContextType, Partial<MutationUpdateAssetsOnVenueEventArgs>>;
  updateAuctionSettings?: Resolver<Maybe<ResolversTypes['AuctionSettingsResponse']>, ParentType, ContextType, Partial<MutationUpdateAuctionSettingsArgs>>;
  updateBIRoles?: Resolver<Maybe<ResolversTypes['HttpResponse']>, ParentType, ContextType, Partial<MutationUpdateBiRolesArgs>>;
  updateDashboardCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateDashboardCardArgs, 'card' | 'cardId'>>;
  updateDocTypeShortCode?: Resolver<Maybe<ResolversTypes['UpdateDocumentsResponse']>, ParentType, ContextType, RequireFields<MutationUpdateDocTypeShortCodeArgs, 'tenantId'>>;
  updateDocument?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<MutationUpdateDocumentArgs, 'updateDocumentInput'>>;
  updateDocuments?: Resolver<Maybe<ResolversTypes['UpdateDocumentsResponse']>, ParentType, ContextType, RequireFields<MutationUpdateDocumentsArgs, 'tenantId'>>;
  updateFavoriteAccount?: Resolver<Maybe<ResolversTypes['HttpResponse']>, ParentType, ContextType, Partial<MutationUpdateFavoriteAccountArgs>>;
  updateIfOffer?: Resolver<Maybe<ResolversTypes['IfOfferUpdateResults']>, ParentType, ContextType, Partial<MutationUpdateIfOfferArgs>>;
  updateMaintenanceStatus?: Resolver<Maybe<ResolversTypes['MaintenanceUpdateResult']>, ParentType, ContextType, Partial<MutationUpdateMaintenanceStatusArgs>>;
  updateMultipleIfOffers?: Resolver<Maybe<ResolversTypes['IfOfferUpdateResults']>, ParentType, ContextType, Partial<MutationUpdateMultipleIfOffersArgs>>;
  updateRoles?: Resolver<Maybe<ResolversTypes['HttpResponse']>, ParentType, ContextType, RequireFields<MutationUpdateRolesArgs, 'input'>>;
  updateTenantIdAndCreatedAt?: Resolver<Maybe<ResolversTypes['UpdateDocumentsResponse']>, ParentType, ContextType, RequireFields<MutationUpdateTenantIdAndCreatedAtArgs, 'tenantId'>>;
  updateUser?: Resolver<Maybe<ResolversTypes['UserMutationResponse']>, ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'input'>>;
  updateVenueEvent?: Resolver<Maybe<ResolversTypes['CreatedEventResponse']>, ParentType, ContextType, Partial<MutationUpdateVenueEventArgs>>;
  uploadDocument?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUploadDocumentArgs, 'input'>>;
  uploadDocuments?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUploadDocumentsArgs, 'docs'>>;
}>;

export type MutationDataResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MutationDataResponse'] = ResolversParentTypes['MutationDataResponse']> = ResolversObject<{
  __resolveType: TypeResolveFn<'VenueEvent' | 'VenueSaleListingAsset', ParentType, ContextType>;
}>;

export type MutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MutationResponse'] = ResolversParentTypes['MutationResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['MutationDataResponse']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NoSaleHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoSaleHistory'] = ResolversParentTypes['NoSaleHistory']> = ResolversObject<{
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  highBid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnlineListingResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnlineListing'] = ResolversParentTypes['OnlineListing']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mmrValuation?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vdpUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watchCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  watchers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Watcher']>>>, ParentType, ContextType>;
  webViews?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnlineListingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnlineListings'] = ResolversParentTypes['OnlineListings']> = ResolversObject<{
  byAssetId?: Resolver<Maybe<ResolversTypes['OnlineListing']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnlineListing']>>>, ParentType, ContextType, Partial<OnlineListingsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnlineStatisticResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnlineStatistic'] = ResolversParentTypes['OnlineStatistic']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OpenPsiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenPsiResponse'] = ResolversParentTypes['OpenPsiResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  serviceResponses?: Resolver<Maybe<Array<Maybe<ResolversTypes['ServiceResponse']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupOrgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAEAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAuctionUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCorporateGroupUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orgTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Site']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInfoConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfoConfig'] = ResolversParentTypes['PageInfoConfig']> = ResolversObject<{
  csvMaxRows?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  overRidePageLimit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sortColumns?: Resolver<Maybe<Array<Maybe<ResolversTypes['SortColumn']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaginatedDocumentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedDocumentResponse'] = ResolversParentTypes['PaginatedDocumentResponse']> = ResolversObject<{
  itemCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType>;
  nextToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PastSaleResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSale'] = ResolversParentTypes['PastSale']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  buyerAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferHistory']>>>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealOutcome?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventClassCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  highBid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastCounter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastCounterBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noSold?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rejectedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soldAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  venueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueEventTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PastSearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSearch'] = ResolversParentTypes['PastSearch']> = ResolversObject<{
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PathConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['PathConfig'] = ResolversParentTypes['PathConfig']> = ResolversObject<{
  countPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PermissionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PermissionItem'] = ResolversParentTypes['PermissionItem']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PhotoResolvers<ContextType = any, ParentType extends ResolversParentTypes['Photo'] = ResolversParentTypes['Photo']> = ResolversObject<{
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hiresUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_60x50?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_70x53?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_100x75?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_200x150?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_220x165?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_300x231?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_320x240?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_400x300?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_480x360?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_480x480?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_640x480?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pipelineUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  standardUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['Profile'] = ResolversParentTypes['Profile']> = ResolversObject<{
  authenticationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dashboards?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  databaseId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mobilePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['RoleAttributes']>>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PsiResolvers<ContextType = any, ParentType extends ResolversParentTypes['Psi'] = ResolversParentTypes['Psi']> = ResolversObject<{
  inspectionTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['InspectionType']>>>, ParentType, ContextType, Partial<PsiInspectionTypesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PsiNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['PsiNote'] = ResolversParentTypes['PsiNote']> = ResolversObject<{
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sparkUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PushVehicleToAmsResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PushVehicleToAmsResults'] = ResolversParentTypes['PushVehicleToAmsResults']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PushVehiclesToAmsResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PushVehiclesToAmsResults'] = ResolversParentTypes['PushVehiclesToAmsResults']> = ResolversObject<{
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['SinglePushVehicleToAmsResult']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  accessoryDrawerState?: Resolver<Maybe<ResolversTypes['AccessoryDrawerDisplay']>, ParentType, ContextType>;
  activeOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  adminUserAttributes?: Resolver<ResolversTypes['UserAttributes'], ParentType, ContextType, Partial<QueryAdminUserAttributesArgs>>;
  administrator?: Resolver<Maybe<ResolversTypes['Administrator']>, ParentType, ContextType>;
  auction?: Resolver<Maybe<ResolversTypes['Auction']>, ParentType, ContextType, Partial<QueryAuctionArgs>>;
  auctionCollection?: Resolver<Maybe<ResolversTypes['Auction']>, ParentType, ContextType, Partial<QueryAuctionCollectionArgs>>;
  dashboardReflowTrigger?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dashboards?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryDashboardsArgs>>;
  documentTypes?: Resolver<Array<ResolversTypes['DocType']>, ParentType, ContextType>;
  getAgentByAuctionAccess?: Resolver<Maybe<ResolversTypes['QueryAgentResponse']>, ParentType, ContextType, Partial<QueryGetAgentByAuctionAccessArgs>>;
  getVenueEvent?: Resolver<Maybe<ResolversTypes['QueryResponse']>, ParentType, ContextType, Partial<QueryGetVenueEventArgs>>;
  getVenueEventRunList?: Resolver<Maybe<ResolversTypes['QueryRunListResponse']>, ParentType, ContextType, Partial<QueryGetVenueEventRunListArgs>>;
  getVenueEvents?: Resolver<Maybe<ResolversTypes['QueryEventsListResponse']>, ParentType, ContextType, Partial<QueryGetVenueEventsArgs>>;
  isEditingLayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  layouts?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passwordRecoveryEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pastSearches?: Resolver<Maybe<Array<Maybe<ResolversTypes['PastSearch']>>>, ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['RoleAttributes']>, ParentType, ContextType>;
  tempLayouts?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
}>;

export type QueryAgentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryAgentResponse'] = ResolversParentTypes['QueryAgentResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['AgentDealerResponse']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryEventsListResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryEventsListResponse'] = ResolversParentTypes['QueryEventsListResponse']> = ResolversObject<{
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['VenueEvent']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryResponse'] = ResolversParentTypes['QueryResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['VenueEvent']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryRunListResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryRunListResponse'] = ResolversParentTypes['QueryRunListResponse']> = ResolversObject<{
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['VenueSaleListingAsset']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RegisterBidderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterBidderResponse'] = ResolversParentTypes['RegisterBidderResponse']> = ResolversObject<{
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['Report'] = ResolversParentTypes['Report']> = ResolversObject<{
  auctionType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reportLongName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportShortName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportColumnResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportColumn'] = ResolversParentTypes['ReportColumn']> = ResolversObject<{
  header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportConfig'] = ResolversParentTypes['ReportConfig']> = ResolversObject<{
  PK?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SK?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardViewConfig?: Resolver<Maybe<ResolversTypes['ListView']>, ParentType, ContextType>;
  dataConfig?: Resolver<Maybe<ResolversTypes['DataConfig']>, ParentType, ContextType>;
  defaultSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listViewConfig?: Resolver<Maybe<ResolversTypes['ListView']>, ParentType, ContextType>;
  pdfViewConfig?: Resolver<Maybe<ResolversTypes['ListView']>, ParentType, ContextType>;
  reportKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scope?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  searchResults?: Resolver<Maybe<ResolversTypes['ConfigSearchResults']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportDateOffsetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportDateOffset'] = ResolversParentTypes['ReportDateOffset']> = ResolversObject<{
  end?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportDetailPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportDetailPage'] = ResolversParentTypes['ReportDetailPage']> = ResolversObject<{
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requiredRoles?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportSearchFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportSearchFilter'] = ResolversParentTypes['ReportSearchFilter']> = ResolversObject<{
  dataQuery?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOffset?: Resolver<Maybe<ResolversTypes['ReportDateOffset']>, ParentType, ContextType>;
  forFollowup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchType?: Resolver<Maybe<ResolversTypes['SEARCH_TYPES']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResetPasswordByEmailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordByEmailResponse'] = ResolversParentTypes['ResetPasswordByEmailResponse']> = ResolversObject<{
  statusCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoleAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleAttributes'] = ResolversParentTypes['RoleAttributes']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleEvent'] = ResolversParentTypes['SaleEvent']> = ResolversObject<{
  buyerAgentAaNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrgAaNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrgStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealSaleAmt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventEndTs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventEndedAtTs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventStartTs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueEventKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueEventTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleListingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleListing'] = ResolversParentTypes['SaleListing']> = ResolversObject<{
  buyerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPicture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingCondition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingDealSoldAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingOfferCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sequence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soldDateLastRanTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SalesDayStatisticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesDayStatistics'] = ResolversParentTypes['SalesDayStatistics']> = ResolversObject<{
  checkedIn?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  checkedInToday?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  missingCRs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  needsPhotos?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  units?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchAccount'] = ResolversParentTypes['SearchAccount']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountLegacyType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountSalesRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canBuy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canSell?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  establishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFavorite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastAttendedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastBoughtAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSoldAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchAgentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchAgent'] = ResolversParentTypes['SearchAgent']> = ResolversObject<{
  accountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountSalesRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cellPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBadgeIssuedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBadgeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBidderType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchBidderResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchBidder'] = ResolversParentTypes['SearchBidder']> = ResolversObject<{
  BadgeIssuedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BadgeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BidderType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cellPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorLegacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorLegacyType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehiclesPurchasedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchContactLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchContactLog'] = ResolversParentTypes['SearchContactLog']> = ResolversObject<{
  accountAuctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedUserid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorUserid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followUpDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followUpUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupUserid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  update?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResults'] = ResolversParentTypes['SearchResults']> = ResolversObject<{
  accountCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchAccount']>>>, ParentType, ContextType>;
  agentCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchAgent']>>>, ParentType, ContextType>;
  bidderCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bidderResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchBidder']>>>, ParentType, ContextType>;
  contactLogCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contactLogResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchContactLog']>>>, ParentType, ContextType>;
  contactLogStats?: Resolver<Maybe<ResolversTypes['ContactLogStats']>, ParentType, ContextType>;
  searchStringDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchStringJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehicleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehicleInSaleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehicleInSaleResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchVehicle']>>>, ParentType, ContextType>;
  vehicleRecentlySoldCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehicleRecentlySoldResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchVehicle']>>>, ParentType, ContextType>;
  vehicleResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchVehicle']>>>, ParentType, ContextType>;
  vehicleResultCsvUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleStats?: Resolver<Maybe<ResolversTypes['VehicleStats']>, ParentType, ContextType>;
  vehicleStatsByCompany?: Resolver<Maybe<Array<Maybe<ResolversTypes['VehicleStatsByCompany']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchVehicleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchVehicle'] = ResolversParentTypes['SearchVehicle']> = ResolversObject<{
  accountSalesRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allCurrentSales?: Resolver<Maybe<Array<Maybe<ResolversTypes['CurrentSale']>>>, ParentType, ContextType>;
  announcementFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementLight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementOne?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementThree?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementTwo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ballControlCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentAaNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentBadge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAuctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAuctionRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerLegacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerLegacyType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrgAaNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrgStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkedInAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorAuctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorLegacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorLegacyType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorStockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daysOnLot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealCurrentOfferAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasCr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isNew?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationBuyerSellerAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationDealBuyerAccountDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationDealBuyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationDealSoldAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationEventDealCurrentOfferAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationIsOpen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationLastEventCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  odometer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photoCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pipelineUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proxyWon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiAmsPrinterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiAmsServiceResultCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiChargeAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  psiCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiLongDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiOrderedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiOrderedByAmsUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiOrderedBySparkAuthenticationUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiOrderedBySparkUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  psiRackPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiRequested?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiResultBySparkAuthenticationUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiServiceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiShortDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ranAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ranCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  runPadded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleDateLastRanTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAuctionRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soldDateLastRanTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceSystemKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Service'] = ResolversParentTypes['Service']> = ResolversObject<{
  AssetServiceStatusId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsChargeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsPrinterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsServiceProductCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsServiceResultCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  chargeAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationServiceProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceClassCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOrderedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOrderedByAmsUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOrderedByPipelineUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOrderedBySparkUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceProductDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceResultAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceResultByAmsUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceResultBySparkUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceResultedInArbitration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceResponse'] = ResolversParentTypes['ServiceResponse']> = ResolversObject<{
  serviceClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceCodeDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleInfoResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetVehicleInfoResults'] = ResolversParentTypes['SetVehicleInfoResults']> = ResolversObject<{
  cancelProxyBidsResult?: Resolver<Maybe<ResolversTypes['CancelProxyBidsResult']>, ParentType, ContextType>;
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmsCallResult']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShareReportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShareReportResponse'] = ResolversParentTypes['ShareReportResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SinglePushVehicleToAmsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SinglePushVehicleToAmsResult'] = ResolversParentTypes['SinglePushVehicleToAmsResult']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPossible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SiteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Site'] = ResolversParentTypes['Site']> = ResolversObject<{
  auctionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  biCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lookoutCodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pipelineCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SortColumnResolvers<ContextType = any, ParentType extends ResolversParentTypes['SortColumn'] = ResolversParentTypes['SortColumn']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['SORT_DIRECTION']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SparkPaginatedResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SparkPaginatedResponse'] = ResolversParentTypes['SparkPaginatedResponse']> = ResolversObject<{
  __resolveType: TypeResolveFn<'QueryRunListResponse', ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SparkResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SparkResponse'] = ResolversParentTypes['SparkResponse']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CreatedEventResponse' | 'MutationResponse' | 'QueryAgentResponse' | 'QueryEventsListResponse' | 'QueryResponse' | 'ShareReportResponse' | 'UpateAllListingsMutationResponse', ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type StartBidTierResolvers<ContextType = any, ParentType extends ResolversParentTypes['StartBidTier'] = ResolversParentTypes['StartBidTier']> = ResolversObject<{
  amountBelowPriceFloor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceFloorLBound?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceFloorUBound?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TestVehicleAuditLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['TestVehicleAuditLog'] = ResolversParentTypes['TestVehicleAuditLog']> = ResolversObject<{
  account?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auction_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detail_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrendInfo'] = ResolversParentTypes['TrendInfo']> = ResolversObject<{
  avgPerWeekLast90?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last7?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last90?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Trends'] = ResolversParentTypes['Trends']> = ResolversObject<{
  consigned?: Resolver<Maybe<ResolversTypes['TrendInfo']>, ParentType, ContextType>;
  purchased?: Resolver<Maybe<ResolversTypes['TrendInfo']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['TrendInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpateAllListingsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpateAllListingsMutationResponse'] = ResolversParentTypes['UpateAllListingsMutationResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateDocumentsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateDocumentsResponse'] = ResolversParentTypes['UpdateDocumentsResponse']> = ResolversObject<{
  totalDocsUpdated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalVehiclesUpdated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  attributes?: Resolver<Maybe<ResolversTypes['UserAttributes']>, ParentType, ContextType>;
  biRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dashboardList?: Resolver<Maybe<ResolversTypes['Dashboards']>, ParentType, ContextType, Partial<UserDashboardListArgs>>;
  dashboards?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  organizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Organization']>>>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<ResolversTypes['UserPermissions']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoleAttributes']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAttributes'] = ResolversParentTypes['UserAttributes']> = ResolversObject<{
  auctionAccessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  databaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isGlobalAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSeenAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lockedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lockedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobilePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMutationResponse'] = ResolversParentTypes['UserMutationResponse']> = ResolversObject<{
  auctionAccessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  databaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isGlobalAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobilePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserPermissionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPermissions'] = ResolversParentTypes['UserPermissions']> = ResolversObject<{
  orgPermissions?: Resolver<Maybe<Array<Maybe<ResolversTypes['PermissionItem']>>>, ParentType, ContextType, RequireFields<UserPermissionsOrgPermissionsArgs, 'auctionId'>>;
  userPermissions?: Resolver<Maybe<Array<Maybe<ResolversTypes['PermissionItem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VdpByStockNumberResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VdpByStockNumberResults'] = ResolversParentTypes['VdpByStockNumberResults']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  uaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehicleAmsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VehicleAMSResponse'] = ResolversParentTypes['VehicleAMSResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehicleDataTypesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VehicleDataTypes'] = ResolversParentTypes['VehicleDataTypes']> = ResolversObject<{
  __resolveType: TypeResolveFn<'OnlineListing' | 'SearchVehicle' | 'VehicleStatsByCompany', ParentType, ContextType>;
}>;

export type VehicleStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VehicleStats'] = ResolversParentTypes['VehicleStats']> = ResolversObject<{
  avgSaleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ran?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sumSaleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehicleStatsByCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['VehicleStatsByCompany'] = ResolversParentTypes['VehicleStatsByCompany']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avgSaleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ran?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sumSaleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehiclesWithDocsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VehiclesWithDocsResponse'] = ResolversParentTypes['VehiclesWithDocsResponse']> = ResolversObject<{
  totalDocCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehiclesWithDocsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VenueEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['VenueEvent'] = ResolversParentTypes['VenueEvent']> = ResolversObject<{
  endedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventSettings?: Resolver<Maybe<ResolversTypes['AuctionSettings']>, ParentType, ContextType>;
  eventStartTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventTags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  eventTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventTypeDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noSale?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  onOffer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originatingOrgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  participatingAuctions?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  sales?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unitCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  venueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VenueSaleListingAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['VenueSaleListingAsset'] = ResolversParentTypes['VenueSaleListingAsset']> = ResolversObject<{
  announcementLight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  assetOrigin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bidIncrement?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  blackBook?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyNowPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  grade?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hasCr?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingCondition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mmr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ranCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleListingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startBid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WatcherResolvers<ContextType = any, ParentType extends ResolversParentTypes['Watcher'] = ResolversParentTypes['Watcher']> = ResolversObject<{
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PushToAmsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['pushToAMSResponse'] = ResolversParentTypes['pushToAMSResponse']> = ResolversObject<{
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['pushToAMSResposeResult']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PushToAmsResposeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['pushToAMSResposeResult'] = ResolversParentTypes['pushToAMSResposeResult']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['PendingSuccess'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendMessageStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['sendMessageStatus'] = ResolversParentTypes['sendMessageStatus']> = ResolversObject<{
  emailSentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smsSentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  AMSUpdateResponseMessages?: AmsUpdateResponseMessagesResolvers<ContextType>;
  Account?: AccountResolvers<ContextType>;
  AccountGroupAccounts?: AccountGroupAccountsResolvers<ContextType>;
  AccountGroupUsers?: AccountGroupUsersResolvers<ContextType>;
  AccountGroups?: AccountGroupsResolvers<ContextType>;
  AccountNote?: AccountNoteResolvers<ContextType>;
  Accounts?: AccountsResolvers<ContextType>;
  Administrator?: AdministratorResolvers<ContextType>;
  Agent?: AgentResolvers<ContextType>;
  AgentCompany?: AgentCompanyResolvers<ContextType>;
  AgentDealerResponse?: AgentDealerResponseResolvers<ContextType>;
  AgentNote?: AgentNoteResolvers<ContextType>;
  AgentNoteType?: AgentNoteTypeResolvers<ContextType>;
  AgentNoteUpdateResult?: AgentNoteUpdateResultResolvers<ContextType>;
  AgentRole?: AgentRoleResolvers<ContextType>;
  AgentRoleUpdateResult?: AgentRoleUpdateResultResolvers<ContextType>;
  AgentRoleUpdateResults?: AgentRoleUpdateResultsResolvers<ContextType>;
  Agents?: AgentsResolvers<ContextType>;
  AmsCallResult?: AmsCallResultResolvers<ContextType>;
  AmsResponse?: AmsResponseResolvers<ContextType>;
  Announcement?: AnnouncementResolvers<ContextType>;
  Asset?: AssetResolvers<ContextType>;
  AssetFees?: AssetFeesResolvers<ContextType>;
  Assets?: AssetsResolvers<ContextType>;
  Attendance?: AttendanceResolvers<ContextType>;
  AttendanceList?: AttendanceListResolvers<ContextType>;
  Auction?: AuctionResolvers<ContextType>;
  AuctionAmsInfo?: AuctionAmsInfoResolvers<ContextType>;
  AuctionCollection?: AuctionCollectionResolvers<ContextType>;
  AuctionKey?: AuctionKeyResolvers<ContextType>;
  AuctionSettings?: AuctionSettingsResolvers<ContextType>;
  AuctionSettingsResponse?: AuctionSettingsResponseResolvers<ContextType>;
  AuctionStatistics?: AuctionStatisticsResolvers<ContextType>;
  Audit?: AuditResolvers<ContextType>;
  AuditResponse?: AuditResponseResolvers<ContextType>;
  Bidder?: BidderResolvers<ContextType>;
  BidderList?: BidderListResolvers<ContextType>;
  BiddingStatistics?: BiddingStatisticsResolvers<ContextType>;
  BuyNowTier?: BuyNowTierResolvers<ContextType>;
  CacheShape?: CacheShapeResolvers<ContextType>;
  CalculatedIfOfferData?: CalculatedIfOfferDataResolvers<ContextType>;
  CancelProxyBidsResult?: CancelProxyBidsResultResolvers<ContextType>;
  Card?: CardResolvers<ContextType>;
  CompaniesList?: CompaniesListResolvers<ContextType>;
  ConditionReport?: ConditionReportResolvers<ContextType>;
  ConfigSearchResults?: ConfigSearchResultsResolvers<ContextType>;
  Contact?: ContactResolvers<ContextType>;
  ContactList?: ContactListResolvers<ContextType>;
  ContactLogStats?: ContactLogStatsResolvers<ContextType>;
  ContactManagement?: ContactManagementResolvers<ContextType>;
  ContactStatus?: ContactStatusResolvers<ContextType>;
  ContactType?: ContactTypeResolvers<ContextType>;
  CreateDocumentOutputAsset?: CreateDocumentOutputAssetResolvers<ContextType>;
  CreateDocumentUploadDoc?: CreateDocumentUploadDocResolvers<ContextType>;
  CreateDocumentsUploadItem?: CreateDocumentsUploadItemResolvers<ContextType>;
  CreateReportConfigResponse?: CreateReportConfigResponseResolvers<ContextType>;
  CreatedEventResponse?: CreatedEventResponseResolvers<ContextType>;
  CurrentSale?: CurrentSaleResolvers<ContextType>;
  Dashboard?: DashboardResolvers<ContextType>;
  Dashboards?: DashboardsResolvers<ContextType>;
  DataConfig?: DataConfigResolvers<ContextType>;
  Deal?: DealResolvers<ContextType>;
  Dealer?: DealerResolvers<ContextType>;
  DocType?: DocTypeResolvers<ContextType>;
  Document?: DocumentResolvers<ContextType>;
  DocumentActivity?: DocumentActivityResolvers<ContextType>;
  DocumentUploadURL?: DocumentUploadUrlResolvers<ContextType>;
  DocumentView?: DocumentViewResolvers<ContextType>;
  EventTypeTrigger?: EventTypeTriggerResolvers<ContextType>;
  GenericCard?: GenericCardResolvers<ContextType>;
  HttpResponse?: HttpResponseResolvers<ContextType>;
  IfOfferHistory?: IfOfferHistoryResolvers<ContextType>;
  IfOfferManagement?: IfOfferManagementResolvers<ContextType>;
  IfOfferNotes?: IfOfferNotesResolvers<ContextType>;
  IfOfferUpdateAMSResponse?: IfOfferUpdateAmsResponseResolvers<ContextType>;
  IfOfferUpdateResult?: IfOfferUpdateResultResolvers<ContextType>;
  IfOfferUpdateResults?: IfOfferUpdateResultsResolvers<ContextType>;
  InspectionType?: InspectionTypeResolvers<ContextType>;
  InspectionTypeFilter?: InspectionTypeFilterResolvers<ContextType>;
  Lane?: LaneResolvers<ContextType>;
  LaneList?: LaneListResolvers<ContextType>;
  LightOption?: LightOptionResolvers<ContextType>;
  ListView?: ListViewResolvers<ContextType>;
  LocalCreateDocumentOutput?: LocalCreateDocumentOutputResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  LoginResponse?: LoginResponseResolvers<ContextType>;
  MaintenanceUpdateResult?: MaintenanceUpdateResultResolvers<ContextType>;
  Marketplace?: MarketplaceResolvers<ContextType>;
  MarketplaceStatistics?: MarketplaceStatisticsResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  MutationDataResponse?: MutationDataResponseResolvers<ContextType>;
  MutationResponse?: MutationResponseResolvers<ContextType>;
  NoSaleHistory?: NoSaleHistoryResolvers<ContextType>;
  OnlineListing?: OnlineListingResolvers<ContextType>;
  OnlineListings?: OnlineListingsResolvers<ContextType>;
  OnlineStatistic?: OnlineStatisticResolvers<ContextType>;
  OpenPsiResponse?: OpenPsiResponseResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  PageInfoConfig?: PageInfoConfigResolvers<ContextType>;
  PaginatedDocumentResponse?: PaginatedDocumentResponseResolvers<ContextType>;
  PastSale?: PastSaleResolvers<ContextType>;
  PastSearch?: PastSearchResolvers<ContextType>;
  PathConfig?: PathConfigResolvers<ContextType>;
  PermissionItem?: PermissionItemResolvers<ContextType>;
  Photo?: PhotoResolvers<ContextType>;
  Profile?: ProfileResolvers<ContextType>;
  Psi?: PsiResolvers<ContextType>;
  PsiNote?: PsiNoteResolvers<ContextType>;
  PushVehicleToAmsResults?: PushVehicleToAmsResultsResolvers<ContextType>;
  PushVehiclesToAmsResults?: PushVehiclesToAmsResultsResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QueryAgentResponse?: QueryAgentResponseResolvers<ContextType>;
  QueryEventsListResponse?: QueryEventsListResponseResolvers<ContextType>;
  QueryResponse?: QueryResponseResolvers<ContextType>;
  QueryRunListResponse?: QueryRunListResponseResolvers<ContextType>;
  RegisterBidderResponse?: RegisterBidderResponseResolvers<ContextType>;
  Report?: ReportResolvers<ContextType>;
  ReportColumn?: ReportColumnResolvers<ContextType>;
  ReportConfig?: ReportConfigResolvers<ContextType>;
  ReportDateOffset?: ReportDateOffsetResolvers<ContextType>;
  ReportDetailPage?: ReportDetailPageResolvers<ContextType>;
  ReportSearchFilter?: ReportSearchFilterResolvers<ContextType>;
  ResetPasswordByEmailResponse?: ResetPasswordByEmailResponseResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RoleAttributes?: RoleAttributesResolvers<ContextType>;
  SaleEvent?: SaleEventResolvers<ContextType>;
  SaleListing?: SaleListingResolvers<ContextType>;
  SalesDayStatistics?: SalesDayStatisticsResolvers<ContextType>;
  SearchAccount?: SearchAccountResolvers<ContextType>;
  SearchAgent?: SearchAgentResolvers<ContextType>;
  SearchBidder?: SearchBidderResolvers<ContextType>;
  SearchContactLog?: SearchContactLogResolvers<ContextType>;
  SearchResults?: SearchResultsResolvers<ContextType>;
  SearchVehicle?: SearchVehicleResolvers<ContextType>;
  Service?: ServiceResolvers<ContextType>;
  ServiceResponse?: ServiceResponseResolvers<ContextType>;
  SetVehicleInfoResults?: SetVehicleInfoResultsResolvers<ContextType>;
  ShareReportResponse?: ShareReportResponseResolvers<ContextType>;
  SinglePushVehicleToAmsResult?: SinglePushVehicleToAmsResultResolvers<ContextType>;
  Site?: SiteResolvers<ContextType>;
  SortColumn?: SortColumnResolvers<ContextType>;
  SparkPaginatedResponse?: SparkPaginatedResponseResolvers<ContextType>;
  SparkResponse?: SparkResponseResolvers<ContextType>;
  StartBidTier?: StartBidTierResolvers<ContextType>;
  TestVehicleAuditLog?: TestVehicleAuditLogResolvers<ContextType>;
  TrendInfo?: TrendInfoResolvers<ContextType>;
  Trends?: TrendsResolvers<ContextType>;
  UpateAllListingsMutationResponse?: UpateAllListingsMutationResponseResolvers<ContextType>;
  UpdateDocumentsResponse?: UpdateDocumentsResponseResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserAttributes?: UserAttributesResolvers<ContextType>;
  UserMutationResponse?: UserMutationResponseResolvers<ContextType>;
  UserPermissions?: UserPermissionsResolvers<ContextType>;
  VdpByStockNumberResults?: VdpByStockNumberResultsResolvers<ContextType>;
  VehicleAMSResponse?: VehicleAmsResponseResolvers<ContextType>;
  VehicleDataTypes?: VehicleDataTypesResolvers<ContextType>;
  VehicleStats?: VehicleStatsResolvers<ContextType>;
  VehicleStatsByCompany?: VehicleStatsByCompanyResolvers<ContextType>;
  VehiclesWithDocsResponse?: VehiclesWithDocsResponseResolvers<ContextType>;
  VenueEvent?: VenueEventResolvers<ContextType>;
  VenueSaleListingAsset?: VenueSaleListingAssetResolvers<ContextType>;
  Watcher?: WatcherResolvers<ContextType>;
  pushToAMSResponse?: PushToAmsResponseResolvers<ContextType>;
  pushToAMSResposeResult?: PushToAmsResposeResultResolvers<ContextType>;
  sendMessageStatus?: SendMessageStatusResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = any> = ResolversObject<{
  aws_api_key?: Aws_Api_KeyDirectiveResolver<any, any, ContextType>;
  aws_auth?: Aws_AuthDirectiveResolver<any, any, ContextType>;
  aws_cognito_user_pools?: Aws_Cognito_User_PoolsDirectiveResolver<any, any, ContextType>;
  aws_iam?: Aws_IamDirectiveResolver<any, any, ContextType>;
  aws_lambda?: Aws_LambdaDirectiveResolver<any, any, ContextType>;
  aws_oidc?: Aws_OidcDirectiveResolver<any, any, ContextType>;
  aws_publish?: Aws_PublishDirectiveResolver<any, any, ContextType>;
  aws_subscribe?: Aws_SubscribeDirectiveResolver<any, any, ContextType>;
  defer?: DeferDirectiveResolver<any, any, ContextType>;
}>;

export type GetDetailPageFieldQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetDetailPageFieldQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', reportDetailPages: Array<{ __typename?: 'ReportDetailPage', name: string, displayName: string, url: string, requiredRoles?: Array<string> | null }> } | null };

export type BidderStatsQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  searchString: Scalars['String'];
  searchStringOnline: Scalars['String'];
}>;


export type BidderStatsQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', totalbidders?: { __typename?: 'SearchResults', bidderCount?: number | null } | null, onlinebidders?: { __typename?: 'SearchResults', bidderCount?: number | null } | null } | null };

export type FavoriteSellersQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type FavoriteSellersQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', accountCount?: number | null, accountResult?: Array<{ __typename?: 'SearchAccount', accountId?: string | null, displayName?: string | null, isFavorite?: boolean | null } | null> | null } | null, detail?: { __typename?: 'SearchResults', accountCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleStatsByCompany?: Array<{ __typename?: 'VehicleStatsByCompany', accountName?: string | null, accountId?: number | null, total?: number | null, ran?: number | null, sold?: number | null, conversion?: number | null, avgSaleAmount?: number | null, sumSaleAmount?: number | null } | null> | null } | null } | null };


export const GetDetailPageFieldDocument = gql`
    query getDetailPageField($auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    reportDetailPages {
      name
      displayName
      url
      requiredRoles
    }
  }
}
    `;

/**
 * __useGetDetailPageFieldQuery__
 *
 * To run a query within a React component, call `useGetDetailPageFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailPageFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailPageFieldQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetDetailPageFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>(GetDetailPageFieldDocument, options);
      }
export function useGetDetailPageFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>(GetDetailPageFieldDocument, options);
        }
export type GetDetailPageFieldQueryHookResult = ReturnType<typeof useGetDetailPageFieldQuery>;
export type GetDetailPageFieldLazyQueryHookResult = ReturnType<typeof useGetDetailPageFieldLazyQuery>;
export type GetDetailPageFieldQueryResult = ApolloReactCommon.QueryResult<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>;
export const BidderStatsDocument = gql`
    query bidderStats($auctionId: String, $searchString: String!, $searchStringOnline: String!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    totalbidders: search(filter: {type: BIDDERS, searchString: $searchString}) {
      bidderCount
    }
    onlinebidders: search(
      filter: {type: BIDDERS, searchString: $searchStringOnline}
    ) {
      bidderCount
    }
  }
}
    `;

/**
 * __useBidderStatsQuery__
 *
 * To run a query within a React component, call `useBidderStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidderStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidderStatsQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      searchString: // value for 'searchString'
 *      searchStringOnline: // value for 'searchStringOnline'
 *   },
 * });
 */
export function useBidderStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidderStatsQuery, BidderStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidderStatsQuery, BidderStatsQueryVariables>(BidderStatsDocument, options);
      }
export function useBidderStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidderStatsQuery, BidderStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidderStatsQuery, BidderStatsQueryVariables>(BidderStatsDocument, options);
        }
export type BidderStatsQueryHookResult = ReturnType<typeof useBidderStatsQuery>;
export type BidderStatsLazyQueryHookResult = ReturnType<typeof useBidderStatsLazyQuery>;
export type BidderStatsQueryResult = ApolloReactCommon.QueryResult<BidderStatsQuery, BidderStatsQueryVariables>;
export const FavoriteSellersDocument = gql`
    query favoriteSellers($auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(filter: {searchString: "fav:yes", type: BROAD}) {
      accountCount
      accountResult {
        accountId
        displayName
        isFavorite
      }
    }
    detail: search(filter: {searchString: "fav:yes", type: VEHICLES_BY_COMPANY}) {
      accountCount
      searchStringDisplay
      searchType
      vehicleStatsByCompany {
        accountName
        accountId
        total
        ran
        sold
        conversion
        avgSaleAmount
        sumSaleAmount
      }
    }
  }
}
    `;

/**
 * __useFavoriteSellersQuery__
 *
 * To run a query within a React component, call `useFavoriteSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteSellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteSellersQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useFavoriteSellersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FavoriteSellersQuery, FavoriteSellersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FavoriteSellersQuery, FavoriteSellersQueryVariables>(FavoriteSellersDocument, options);
      }
export function useFavoriteSellersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FavoriteSellersQuery, FavoriteSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FavoriteSellersQuery, FavoriteSellersQueryVariables>(FavoriteSellersDocument, options);
        }
export type FavoriteSellersQueryHookResult = ReturnType<typeof useFavoriteSellersQuery>;
export type FavoriteSellersLazyQueryHookResult = ReturnType<typeof useFavoriteSellersLazyQuery>;
export type FavoriteSellersQueryResult = ApolloReactCommon.QueryResult<FavoriteSellersQuery, FavoriteSellersQueryVariables>;